// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/vip-services-img/vip_servies_herobg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/vip-services-img/vip_servies_herobg_light.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/vip-services-img/vip_primebg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/images/vip-services-img/vip_cardbg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vip_hero_section {
    width: 100%;
    text-align: center;
    background-color: #181a20;
    min-height: 816px;
    position: relative;
    display: flex;
    align-items: center;
    color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-position: center top;
    background-repeat: no-repeat;
}

body.light_theme .vip_hero_section {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.vip_hero_section:before {
    width: 100%;
    height: 150px;
    content: "";
    position: absolute;
    /* top: 0px; */
    bottom: 0px;
    background: linear-gradient(0deg, #181A20 -10%, rgba(4, 4, 4, 0) 100%);
}

.vip_hero_img {
    max-width: 530px;
    margin: 0 auto;
}

.vip_hero_section h1 {
    background: linear-gradient(270deg, #FFF3D1 0%, #ffeed1 30%, #D1AA67 70%, #A67C33 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 800;
    letter-spacing: 1.2px;
    margin-top: 24px;
    display: inline-block;
    filter: drop-shadow(0px 4px 15px rgba(209, 170, 103, 0.35));
    transition: all 0.3s ease;
}

body.light_theme .vip_hero_section h1 {
    background: linear-gradient(135deg, #C49A4C 0%, #9D7A3F 40%, #6E511E 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    filter: drop-shadow(0px 2px 8px rgba(157, 122, 63, 0.2));
}

.vip_hero_section p {
    font-size: 24px;
    background: linear-gradient(90deg, #E6C285 0%, #F5D186 50%, #E6C285 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    padding-top: 8px;
    font-weight: 500;
    letter-spacing: 0.5px;
}

.vip_cnt_mdp {
    margin-top: 84px;
    position: relative;
    z-index: 999;
}

.vip {
    justify-content: center;
    padding-top: 15px;
    gap: 24px;
}

.vip button {
    font-size: 20px;
    padding: 18px 48px;
    border: 1px solid #D7B46A;
    background-color: transparent;
    color: #F5D186;
    border-radius: 100px;
    font-weight: 400;
}

.vip button.applybtn,
.vip a.applybtn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 18px 48px;
    border: 1px solid #D1AA67;
    border-radius: 100px;
    font-weight: 400;
    background: #D1AA67;
    color: #000;
    text-decoration: none;
}

.vip a.vip-hero-secondary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 18px 48px;
    border: 1px solid #D7B46A;
    background-color: transparent;
    color: #F5D186;
    border-radius: 100px;
    font-weight: 400;
    text-decoration: none;
}

.vip a.applybtn:hover,
.vip a.vip-hero-secondary:hover {
    opacity: 0.92;
    color: #000;
}

.vip a.vip-hero-secondary:hover {
    color: #F5D186;
}

/* VIP Tier Section Styles */
.vip_tier_section {
    background-color: #181A20;
    padding: 100px 0 100px;
    color: #fff;
}

.vip_tier_content {
    width: 100%;
}

.vip_tier_title_container {
    text-align: center;
    margin-bottom: 40px;
}

.vip_tier_title {
    font-size: 40px;
    font-weight: 600;
    color: #fff;
    display: inline-block;
    border-bottom: 4px solid #D1AA67;
    padding-bottom: 4px;
    letter-spacing: 0.5px;
}

.vip_tier_table_wrapper {
    max-width: 1200px;
    margin: 0 auto;
    background: #1b1d24;
    /* border: 1px solid #0D0D0D; */
    border-radius: 12px 12px 0px 0px;
    overflow: hidden;
}

.vip_tier_table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 5px;
    margin-top: -5px;
    text-align: left;
}

.vip_tier_table th {
    background: linear-gradient(0deg, rgba(2, 2, 2, 1) 0%, rgba(19, 19, 19, 1) 100%);
    color: #D1AA67;
    font-size: 20px;
    font-weight: 500;
    border-top: 2px solid #D1AA67;
    padding: 22px 24px;
}

.vip_tier_table td td.first_td {
    padding: 0px;
}

.tier_badge img.table_vector_effect {
    position: absolute;
    left: 0px;
    top: 0px;
    bottom: 0px;
    /* width: 228px; */
    height: 100%;
}

.vip_tier_table tbody tr {
    /* margin-top: 20px; */
    position: relative;
}

.vip_tier_table td {
    padding: 10px 24px;
    font-size: 18px;
    font-weight: 500;
    color: #F7F8F9;
    border-bottom: none;
    vertical-align: middle;
}

body.light_theme .vip_tier_table td {
    border-bottom: 1px solid #0D0D0D;
}

.vip_tier_table td.first_td {
    min-width: 203px;
}

.vip_tier_table tr:last-child td {
    border-bottom: none;
}

.tier_badge {
    display: flex;
    align-items: center;
    max-width: 112px;
}

.tier_badge img {
    height: 48px;
    width: auto;
    object-fit: contain;
}

/* VIP Prime Section Styles */
.vip_prime_section {
    background-color: #000000;
    padding: 60px 0 50px;
    color: #fff;
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: 1210px;
    background-position: center top;
    background-repeat: no-repeat;
}

.vip_prime_section::before {
    width: 100%;
    height: 420px;
    content: "";
    position: absolute;
    top: 0px;
    /* bottom: 0px; */
    background: linear-gradient(0deg, rgb(0 0 0) -10%, rgb(4 4 4 / 45%) 100%);
}

.vip_prime_title_container {
    padding-top: 120px;
    padding-bottom: 30px;
    text-align: center;
    margin-bottom: 50px;
}

img.vip_heading_vector {
    position: absolute;
    top: -60px;
    margin: 0 auto;
    max-width: 370px;
    left: 0px;
    right: 0px;
}

span.tier_subtext {
    color: #ffffff;
    text-transform: uppercase;
    font-weight: 600;
    padding-left: 45px;
    font-size: 24px;
    position: relative;
    left: -28px;
}

.tier_badge img {
    position: relative;
    z-index: 666;
}

.vip_prime_title {
    font-size: 60px;
    font-weight: 600;
    color: #edd3a5;
    display: inline-block;
    position: relative;
    line-height: 110%;
    letter-spacing: 0.5px;
    max-width: 160px;
}

.vip_prime_section .container {
    position: relative;
}

.vip_prime_cards_container {
    max-width: 1200px;
    margin: 0 auto;
}

.vip_prime_card {
    display: flex;
    background: #040404;
    border: 1px solid #d1aa6761;
    border-radius: 20px;
    overflow: hidden;
    margin-bottom: 24px;
    transition: all 0.3s ease;
    position: relative;
}

img.vip_right_vector {
    position: absolute;
    right: 0px;
    top: 0px;
    max-width: 486px;
    height: 100%;
}

.vip_prime_card.gempoolprime .join_btn {
    background: #3FD174;
}

.vip_prime_card.gempoolprime .right_value {
    color: #3FD174;
}

.vip_prime_card.mining_prime .join_btn {
    background: #986FF5;
}

.vip_prime_card.mining_prime .right_value {
    color: #986FF5
}

.vip_prime_card:hover {
    border-color: rgba(209, 170, 103, 0.6);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.8), 0 0 20px rgba(209, 170, 103, 0.15);
    transform: translateY(-8px);
}

.vip_prime_card_left {
    flex: 1 1;
    padding: 32px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 32px;
}

.vip_prime_card_right {
    width: 250px;
    padding: 30px 0px;
    display: flex;
    flex-direction: column;
    margin-right: 80px;
    justify-content: center;
}

.coin_info {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    gap: 12px;
}

.vip_prime_card .coin_icon {
    height: 40px;
    width: 40px;
    object-fit: contain;
    top: 0px;
    margin: 0px;
    border: none;
    background-color: transparent;
}

body.light_theme .benifitsbtn.one .benifits_vector {
    filter: invert(1);
}

.coin_name {
    font-size: 24px;
    font-weight: 500;
    color: #fff;
}

.vip_prime_card.gempoolprime {
    border-color: #072914;
}

.vip_prime_card.mining_prime {
    border-color: #221232;
}

.coin_subname {
    font-size: 14px;
    color: #888;
    font-weight: 400;
}

.coin_desc {
    font-size: 14px;
    color: #888;
    margin-left: 12px;
    font-weight: 400;
}

.metrics_container {
    display: flex;
    gap: 80px;
}

.metric_col {
    display: flex;
    flex-direction: column;
}

.metric_label {
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
}

.metric_value {
    font-size: 28px;
    font-weight: 600;
    color: #fff;
    display: flex;
    align-items: center;
}

.metric_unit {
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    margin-left: 6px;
}

body.light_theme .vip_hero_section p {
    background: linear-gradient(90deg, #E6C285 0%, #b78d38 50%, #E6C285 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.gold_badge {
    background: #2C2819;
    color: #FFC400;
    font-size: 13px;
    font-weight: 500;
    padding: 3px 8px;
    border-radius: 4px;
    margin-left: 12px;
}

.special_boost_text {
    font-size: 14px;
    color: #FFC400;
    margin-top: 16px;
    font-weight: 500;
}

/* Right Side Styles */
.right_title_row {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    position: relative;
    z-index: 666;
}

.right_title {
    font-size: 20px;
    font-weight: 500;
    color: #F3F3F3;
}

.vip_pill_badge {
    background: linear-gradient(90deg, rgba(208, 170, 0, 1) 0%, rgba(255, 214, 109, 1) 50%, rgba(224, 162, 31, 1) 100%);
    color: #000;
    font-size: 11px;
    font-weight: 500;
    padding: 3px 6px;
    border-radius: 4px;
    margin-left: 8px;
    text-transform: uppercase;
}

.right_metric {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    position: relative;
    z-index: 666;
}

.right_label {
    font-size: 13px;
    color: #888;
    margin-bottom: 6px;
}

.right_value {
    font-size: 36px;
    font-weight: 500;
    color: #F5D186;
    display: flex;
    align-items: center;
    justify-content: start;
}

.arrow_up,
.arrow_down {
    margin-right: 6px;
    font-size: 24px;
    vertical-align: middle;
}

.join_btn {
    width: 100%;
    background: #D1AA67;
    color: #000;
    font-size: 15px;
    position: relative;
    z-index: 666;
    font-weight: 600;
    padding: 10px 0;
    border: none;
    border-radius: 100px;
    cursor: pointer;
    transition: transform 0.2s ease, opacity 0.2s ease;
}

.join_btn:hover {
    transform: translateY(-2px);
    opacity: 0.95;
}

.vip_cards_section {
    width: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    min-height: 700px;
    background-position: bottom center;
    background-repeat: no-repeat;
    background-color: #181A20;
    padding-top: 155px;
    position: relative;
}

.vip_cards_section::before {
    width: 100%;
    height: 100%;
    content: "";
    position: absolute;
    top: 0px;
    bottom: 0px;
    background: linear-gradient(0deg, rgba(4, 4, 4, 1) 0%, rgba(4, 4, 4, 0) 100%);
}

.vip_cards_img {
    max-width: 384px;
    margin: 0 auto;
    position: relative;
    z-index: 666;
}

.vip_features_section {
    width: 100%;
    display: block;
    text-align: center;
    background-color: #181A20;
    color: #fff;
    padding: 30px 0px 140px;
}

.vip_features_section h2 {
    font-size: 40px;
    font-weight: 600;
}

.vip_cnt_block {
    width: 100%;
    display: flex;
    text-align: left;
    gap: 24px;
    align-items: center;
    position: relative;
}

.vip_cnt_block.firstblock {
    top: -20px;
    left: 45px;
}

.vip_cnt_block.lastblock {
    top: 29px;
    left: 60px;
}

.vip_features_section h3 {
    font-size: 24px;
    font-weight: 600;
}

.vip_features_section h3 span {
    color: #D1AA67;
}

.vip_features_section p {
    font-size: 15px;
    color: #f3f3f399;
}

.cnt_vip_bl {
    max-width: 280px;
}

.vip_features_vector {
    min-width: 90px;
}

.vip_features_cntblock.vip_rightside .vip_cnt_block {
    flex-direction: row-reverse;
    padding-left: 15px;
}

.vip_features_cntblock.vip_rightside .vip_cnt_block.firstblock {
    left: -45px;
}

.vip_features_cntblock.vip_rightside .vip_cnt_block.lastblock {
    left: -60px;
}


.vip_features_cntblock {
    width: 375px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 34px;
    margin-top: 88px;
    padding-right: 10px;
}

.vip_features_midbl {
    width: 670px;
    max-width: 100%;
    position: relative;
}

.vip_features_block {
    width: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    margin-top: 48px;
}

.vip_feature_middle_img {
    width: 520px;
    margin: 0 auto;
    max-width: 100%;
    /* position: relative; */
    /* z-index: 999; */
    margin-top: 70px;
}

img.vip_effect_middle {
    position: absolute;
    left: 0px;
    top: 0px;
}


/* Mobile Details Modal */
.mobile_more_btn {
    display: none;
}

.vip_tier_modal_overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgb(0 0 0 / 83%);
    display: flex;
    align-items: end;
    justify-content: center;
    z-index: 99999999;
    padding: 0px;
}

.vip_tier_modal_content {
    background: #505050d1;
    border-radius: 16px 16px 0px 0px;
    width: 100%;
    max-width: 400px;
    padding: 24px;
    box-shadow: 0 10px 40px rgb(0 0 0 / 22%);
    position: relative;
}

.vip_tier_modal_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.vip_tier_modal_header h3 {
    color: #ffffff;
    margin: 0;
    font-size: 20px;
}

.close_modal_btn {
    background: none;
    border: none;
    color: #fff;
    padding: 0px;
    font-size: 28px;
    cursor: pointer;
    line-height: 1;
}

.modal_detail_row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.modal_detail_row:last-child {
    border-bottom: none;
}

.modal_detail_label {
    color: #d8d8d8;
    font-size: 14px;
}

.modal_detail_value {
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    text-align: right;
}

.modal_tier_badge {
    margin: 0;
}

.benifitsbtn {
    display: inline-flex;
    align-items: center;
    padding: 12px 24px;
    border-radius: 6px;
    font-weight: 500;
    gap: 12px;
    color: #fff;
    background-color: #121212;
    width: 280px;
    border: 1px solid transparent;
    border-right-width: 5px;
    font-size: 16px;
    justify-content: flex-start;
    transition: all 0.3s ease;
}

.benifitsbtn.one {
    border-color: rgba(160, 160, 160, 0.15);
    border-right-color: #a0a0a0;
    box-shadow: 0 0 15px rgba(160, 160, 160, 0.05);
}

.benifitsbtn.two {
    border-color: rgba(230, 138, 0, 0.15);
    border-right-color: #e68a00;
    box-shadow: 0 0 15px rgba(230, 138, 0, 0.05);
}

.benifitsbtn.three {
    border-color: rgba(63, 209, 116, 0.15);
    border-right-color: #3FD174;
    box-shadow: 0 0 15px rgba(63, 209, 116, 0.05);
}

.benifitsbtn.four {
    border-color: rgba(41, 121, 255, 0.15);
    border-right-color: #2979ff;
    box-shadow: 0 0 15px rgba(41, 121, 255, 0.05);
}

.benifitsbtn.five {
    border-color: rgba(168, 85, 247, 0.15);
    border-right-color: #a855f7;
    box-shadow: 0 0 15px rgba(168, 85, 247, 0.05);
}

.commingsoon {
    width: 100%;
    padding: 70px 0px 10px;
    text-align: center;
    background-color: #181A20;
}

.commingsoon h2 {
    font-size: 90px;
    background: linear-gradient(135deg, #e6c285, #905920);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
}

@media (max-width: 1550px) {

    .vip_hero_img {
        max-width: 420px;
    }

    .vip_hero_section {
        min-height: 670px;
    }

    .vip_tier_section {
        padding: 150px 0 100px;
    }

    .vip_cnt_mdp {
        top: 40px;
    }

    .vip_feature_middle_img {
        width: 450px;
    }

}

@media (max-width: 1200px) {

    .vip_feature_middle_img {
        width: 200px;
    }

    .vip_cnt_mdp {
        margin-top: 0px;
    }

    .vip_features_vector {
        min-width: 70px;
    }

    .vip_features_section h3 {
        font-size: 20px;
    }

    .vip_features_section p {
        font-size: 14px;
    }

    .vip_features_cntblock {
        gap: 20px;
        margin-top: 32px;
    }

    .vip_cnt_block.firstblock {
        top: 0px;
        left: 15px;
    }

    .vip_cnt_block.lastblock {
        top: 0px;
        left: 20px;
    }

    .vip_features_section {
        padding: 30px 0px 30px;
    }

    .vip_features_section h2 {
        font-size: 32px;
    }

    .vip_prime_card_left {
        padding: 0px;
    }

    .metric_value {
        font-size: 22px;
    }

    .metrics_container {
        gap: 40px;
    }

    .benifitsbtn {
        padding: 12px 10px;
        width: 190px;
        gap: 6px;
        font-size: 13px;
    }

    .vip_features_midbl {
        width: 420px;
    }


    .vip_hero_section {
        min-height: 550px;
    }

    .vip_hero_img {
        max-width: 300px;
    }

    .vip_cnt_mdp {
        top: 70px;
    }

    .vip_tier_title {
        font-size: 32px;
    }


    .vip_prime_title {
        font-size: 40px;
    }

    .vip_tier_table th {
        font-size: 16px;
    }

    .vip_tier_table td {
        font-size: 15px;
    }



}


/* ===================== VIP Features Responsive ===================== */
@media (max-width: 991px) {

    .vip_features_block {
        flex-direction: column;
        margin-top: 20px;
    }

    span.tier_subtext {
        font-size: 18px;
        top: 3px;
    }


    .tier_badge img.table_vector_effect {
        height: 55px;
        top: -2px;
    }

    .vip_tier_table td.first_td {
        min-width: 152px;
    }

    .tier_badge img {
        height: 32px;
        top: 3px;
    }

    .vip_tier_table td {
        padding: 6px 14px;
        font-size: 13px;
    }

    .vip_tier_table th {
        font-size: 13px;
        padding: 14px 12px;
    }

    .metric_value {
        font-size: 20px;
        flex-direction: column;
        align-items: start;
    }

    .gold_badge {
        font-size: 12px;
        margin-left: 0px;
    }

    .metric_unit {
        margin-left: 0px;
    }

    .vip_features_cntblock {
        width: 100%;
        justify-content: space-between;
    }

    .vip_cnt_block.firstblock {
        left: 0px;
    }

    .vip_cnt_block.lastblock {
        top: 0px;
        left: 0px;
    }

    .vip_features_vector {
        min-width: 70px;
        width: 70px;
    }

    img.vip_effect_middle {
        display: none;
    }

    .vip_feature_middle_img {
        width: 300px;
        margin-top: 20px;
        order: 1;
    }

    img.vip_heading_vector {
        top: -30px;
    }

    .vip_features_cntblock.vip_rightside .vip_cnt_block.firstblock {
        left: 0px;
        padding: 0px;
    }

    .vip_cnt_block {
        justify-content: space-between;
        padding: 0px;
    }

    .vip_features_cntblock.vip_rightside .vip_cnt_block {
        padding-left: 0px;
    }

    .vip_features_cntblock.vip_rightside .vip_cnt_block.lastblock {
        left: 0px;
    }

    .cnt_vip_bl {
        max-width: 100%;
        width: 100%;
    }

    .vip_features_cntblock.vip_rightside .vip_cnt_block {
        flex-direction: row;
    }

    .vip_hero_section {
        min-height: 100%;
        padding: 40px 0px;
    }

    .vip_cnt_mdp {
        top: 0px;
        margin-top: 0px;
    }

    .vip_tier_section {
        padding: 40px 0 50px;
    }

    .vip_prime_section {
        padding: 30px 0 50px;
    }

    .vip_tier_title {
        font-size: 26px;
    }

    .commingsoon h2 {
        font-size: 60px;
    }


    .vip_cards_section {
        min-height: 620px;
        padding-top: 80px;
    }

    /* .vip_feature_card_img {
        top: -80px;
    } */

    .vip_hero_section h1 {
        font-size: 24px;
        margin-top: 0px;
    }

    .vip button {
        font-size: 16px;
        padding: 12px 48px;
    }

    .vip_hero_section p {
        font-size: 20px;
    }



    .vip_prime_card .coin_icon {
        padding: 0px;
    }
}



/* Light Theme Overrides */
body.light_theme .vip_hero_section {
    background-color: #ffffff;
    color: #000000;
}

body.light_theme .vip_hero_section:before {
    background: linear-gradient(0deg, rgb(255, 255, 255) -10%, rgba(255, 255, 255, 0) 100%);
}

@media (max-width: 600px) {
    body.light_theme .vip_hero_section:before {
        background: linear-gradient(0deg, rgb(255, 255, 255) -10%, rgba(255, 255, 255, 0.89) 100%);
    }

    .vip_tier_section {
        padding: 30px 0 20px;
    }
}

body.light_theme .vip_hero_section p {
    color: #333333;
}

body.light_theme .vip_tier_section {
    background-color: #fcfcfc;
    color: #000000;
}

body.light_theme .vip_tier_title {
    color: #000000;
}

body.light_theme .vip_tier_table_wrapper {
    background: #ffffff;
    border: 1px solid #eaeaea;
}

body.light_theme .vip_tier_table th {
    background: linear-gradient(0deg, rgba(245, 245, 245, 1) 0%, rgba(255, 255, 255, 1) 100%);
    color: #000000;
    border-top: 2px solid #D1AA67;
}

body.light_theme .vip_tier_table tbody tr {
    /* spacing handled by border-spacing */
}

body.light_theme .vip_tier_table td {
    color: #000000;
    border-bottom: none;
}

body.light_theme .vip_prime_section {
    background-color: #ffffff;
    color: #000000;
}

body.light_theme .vip_prime_section::before {
    background: linear-gradient(0deg, rgb(255, 255, 255) -10%, rgba(255, 255, 255, 0.45) 100%);
}

@media (max-width: 1550px) {
    body.light_theme .vip_prime_section::before {
        background: linear-gradient(0deg, rgb(255, 255, 255) -10%, rgb(255, 255, 255) 100%);
    }
}

body.light_theme span.tier_subtext {
    color: #000000;
}

body.light_theme .vip_prime_card {
    background: #ffffff;
    border-color: #eaeaea;
}

body.light_theme .vip_prime_card.gempoolprime {
    border-color: #e5f5eb;
}

body.light_theme .vip_prime_card.mining_prime {
    border-color: #f2ebff;
}

body.light_theme .coin_name {
    color: #000000;
}

body.light_theme .metric_value {
    color: #000000;
}

body.light_theme .metric_unit {
    color: #000000;
}

body.light_theme .right_title {
    color: #000000;
}

body.light_theme .vip_cards_section {
    background-color: #fcfcfc;
}

body.light_theme .vip_cards_section::before {
    background: linear-gradient(0deg, rgba(252, 252, 252, 1) 0%, rgba(252, 252, 252, 0) 100%);
}

body.light_theme .vip_features_section {
    background-color: #ffffff;
    color: #000000;
}

body.light_theme .vip_features_section p {
    color: #666666;
}

body.light_theme .commingsoon {
    background-color: #fcfcfc;
}

body.light_theme .benifitsbtn {
    background-color: #ffffff;
    color: #000000;
}

body.light_theme .vip_tier_modal_content {
    background: #ffffff;
}

body.light_theme .vip_tier_modal_header h3 {
    color: #000000;
}

body.light_theme .close_modal_btn {
    color: #000000;
}

body.light_theme .modal_detail_row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

body.light_theme .modal_detail_label {
    color: #666666;
}

body.light_theme .modal_detail_value {
    color: #000000;
}

.vip_tier_lead {
    max-width: 720px;
    margin: 16px auto 0;
    color: #cfcfcf;
    font-size: 16px;
    line-height: 1.5;
}

.vip_progress_grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    max-width: 100%;
    margin: 36px auto 12px;
}

.vip_progress_card {
    position: relative;
    background: #1b1d24;
    border: 1px solid rgba(209, 170, 103, 0.35);
    border-radius: 16px;
    padding: 24px;
}

/* .vip_progress_card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, #A67C33, #F5D186, #A67C33);
} */

.vip_progress_head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
}

.vip_progress_market {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
}

.vip_progress_tier {
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.4px;
    color: #1a1408;
    background: linear-gradient(90deg, #F5D186, #D1AA67);
    border-radius: 100px;
    padding: 4px 10px;
    white-space: nowrap;
}

.vip_progress_track {
    height: 8px;
    border-radius: 100px;
    background: #2c303a;
    overflow: hidden;
}

.vip_progress_fill {
    height: 100%;
    border-radius: 100px;
    background: linear-gradient(90deg, #8d6a2f, #F5D186);
}

.vip_progress_scale {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-top: 8px;
    font-size: 12px;
    color: #b5b5b5;
}

.vip_progress_scale span:last-child {
    text-align: right;
}

.vip_progress_remain {
    margin: 12px 0 0;
    font-size: 14px;
    font-weight: 400;
    color: #fcfcfc;
}

body.light_theme .vip_progress_remain {
    color: #5c5c5c;
}

.vip_progress_login {
    display: inline-flex;
    margin-top: 12px;
    color: #D1AA67;
    /* background: #D1AA67; */
    /* border-radius: 100px; */
    /* padding: 8px 16px; */
    gap: 4px;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
}

.vip_progress_fees {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin: 6px 0 0;
    font-size: 13px;
    line-height: 1.45;
    color: #d5d5d5;
}

.vip_progress_note,
.vip_market_note {
    max-width: 1200px;
    margin: 0 auto 22px;
    text-align: center;
    color: #9a9a9a;
    font-size: 13px;
}

.vip_market_note {
    margin-top: 16px;
    margin-bottom: 0;
    line-height: 1.5;
}

.vip_market_tabs {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    max-width: 1200px;
    margin: 100px auto 18px;
}

.vip_market_tab {
    border: 1px solid #D7B46A;
    background: transparent;
    color: #F5D186;
    border-radius: 100px;
    padding: 10px 22px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
}

.vip_market_tab.is-active {
    background: #D1AA67;
    border-color: #D1AA67;
    color: #111;
}

.vip_tier_table .tier_badge {
    max-width: 160px;
}

.vip_tier_table span.tier_subtext {
    font-size: 15px;
    letter-spacing: 0.2px;
}

.vip_tier_table tbody tr.is-current td {
    background: rgba(209, 170, 103, 0.1);
}

.vip_you_tag {
    display: inline-flex;
    margin-left: 8px;
    padding: 2px 8px;
    border-radius: 100px;
    border: 1px solid #D1AA67;
    color: #F5D186;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.3px;
    vertical-align: middle;
}

.benifitsbtn.six {
    border-color: rgba(209, 170, 103, 0.2);
    border-right-color: #D1AA67;
    box-shadow: 0 0 15px rgba(209, 170, 103, 0.08);
}

body.light_theme .vip_tier_lead {
    color: #555;
}

body.light_theme .vip_progress_card {
    background: #fff;
    border-color: rgba(209, 170, 103, 0.45);
}

body.light_theme .vip_progress_market,
body.light_theme .vip_progress_fees {
    color: #1a1a1a;
}

body.light_theme .vip_progress_track {
    background: #efe8da;
}

body.light_theme .vip_progress_scale,
body.light_theme .vip_progress_note,
body.light_theme .vip_market_note {
    color: #666;
}

body.light_theme .vip_market_tab {
    color: #8a6a32;
}

body.light_theme .vip_market_tab.is-active {
    color: #111;
}

body.light_theme .vip_tier_table tbody tr.is-current td {
    background: rgba(209, 170, 103, 0.16);
}

body.light_theme .vip_you_tag {
    color: #8a6a32;
}

@media (max-width: 767px) {
    .vip_tier_table_wrapper {
        overflow: visible;
    }

    .vip_tier_table td {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        text-align: left;
    }

    .vip_tier_table td::before {
        margin-right: 0;
    }

    .mobile_td_right {
        width: 100%;
        justify-content: space-between;
    }

    .vol_text {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        gap: 6px;
        min-width: 0;
    }

    .vip_you_tag {
        margin-left: 0;
    }

    .vip_tier_table td.desktop_only_cell {
        display: flex !important;
    }

    .benifitsbtn {
        width: auto;
        max-width: 100%;
    }
}

@media (max-width: 991px) {
    .vip_progress_grid {
        grid-template-columns: 1fr;
    }

    .vip_tier_lead {
        font-size: 14px;
    }

    .vip_progress_fees {
        font-size: 12px;
    }
}

/* ===== VIP page redesign: unique vx_ classes only (no element selectors) ===== */
.vx_tier_grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
    margin-top: 32px
}

.vx_tier_card {
    --vx-c: #b5b5bd;
    position: relative;
    background: linear-gradient(160deg, #17171b, #101012) !important;
    border: 2px solid #26262b;
    border-top: 3px solid var(--vx-c);
    border-radius: 20px;
    padding: 24px;
    color: #eee;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    transition: border-color 0.25s ease
}

.vx_tier_card * {
    user-select: none;
    -webkit-user-select: none
}

.vx_tier_card ::selection {
    background: transparent
}

.vx_tier_card.vx_c_one {
    --vx-c: #b5b5bd
}

.vx_tier_card.vx_c_two {
    --vx-c: #e08a4a
}

.vx_tier_card.vx_c_three {
    --vx-c: #3ecf8e
}

.vx_tier_card.vx_c_four {
    --vx-c: #4f8cff
}

.vx_tier_card.vx_c_five {
    --vx-c: #a76bff
}

.vx_tier_card.vx_c_six {
    --vx-c: #f1c76a
}

.vx_tier_card.vx_c_one.is-me:hover {
    border-color: #b5b5bd;
    box-shadow: 0px 5px 15px #b5b5bd40;
}

.vx_tier_card.vx_c_two.is-me:hover {
    border-color: #e08a4a;
    box-shadow: 0px 5px 15px #e08a4a40;
}

.vx_tier_card.vx_c_three.is-me:hover {
    border-color: #3ecf8e;
    box-shadow: 0px 5px 15px #3ecf8e40;
}

.vx_tier_card.vx_c_four.is-me:hover {
    border-color: #4f8cff;
    box-shadow: 0px 5px 15px #4f8cff40;
}

.vx_tier_card.vx_c_five.is-me:hover {
    border-color: #a76bff;
    box-shadow: 0px 5px 15px #a76bff40;
}

.vx_tier_card.vx_c_six.is-me:hover {
    border-color: #f1c76a;
    box-shadow: 0px 5px 15px #f1c76a40;
}

.vx_tier_tag {
    position: absolute;
    top: 16px;
    right: 16px;
    background: var(--vx-c);
    color: #111;
    font-size: 11px;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 20px
}

.vx_tier_head {
    display: flex;
    align-items: center;
    gap: 12px;
    background: transparent !important
}

.vx_tier_hex {
    display: inline-flex;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    background: transparent !important
}

.vx_tier_hex img {
    max-width: 100%;
    max-height: 100%
}

.vx_tier_name {
    font-size: 20px;
    font-weight: 700;
    margin: 0;
    color: inherit;
    background: transparent !important
}

.vx_tier_vol {
    color: #9a9aa3;
    font-size: 13px;
    margin: 16px 0 18px;
    background: transparent !important
}

.vx_tier_vol strong {
    display: block;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    margin-top: 3px;
    background: transparent !important
}

.vx_tier_fees {
    display: flex;
    gap: 10px
}

.vx_tier_fee {
    flex: 1 1;
    background: #0b0b0d;
    border-radius: 12px;
    padding: 10px 12px
}

.vx_tier_fee span {
    display: block;
    color: #80808a;
    font-size: 11px
}

.vx_tier_fee strong {
    color: #fff;
    font-size: 16px;
    font-weight: 700
}

.vx_tier_save {
    margin: 14px 0 0;
    font-size: 13px;
    font-weight: 600;
    color: var(--vx-c);
    background: transparent !important
}

.vx_benefits {
    padding: 40px 0 60px
}

.vx_benefits_heading {
    text-align: center;
    font-size: 38px;
    font-weight: 700;
    margin: 0 0 40px;
    color: #fff
}

.vx_benefits_heading span {
    color: #d9b26a
}

.vx_benefit_grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px
}

.vx_benefit {
    position: relative;
    border-radius: 20px;
    padding: 28px;
    transition: transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.28s ease, border-color 0.28s ease;
    cursor: default;
}

.vx_benefit:hover {
    transform: translateY(-4px);
}

.vx_benefit_featured {
    grid-column: span 2;
    display: flex;
    align-items: center;
    gap: 24px;
}

/* Individual Creative Gradients for Dark Theme */
.vx_benefit_gold,
.vx_benefit_grid>.vx_benefit:nth-child(1) {
    background: radial-gradient(120% 120% at 0% 0%, rgba(217, 178, 106, 0.20) 0%, rgba(34, 25, 14, 0.88) 48%, #131316 100%);
    border: 1px solid rgba(217, 178, 106, 0.32);
    box-shadow: 0 4px 20px -8px rgba(0, 0, 0, 0.5);
}

.vx_benefit_gold:hover,
.vx_benefit_grid>.vx_benefit:nth-child(1):hover {
    border-color: rgba(217, 178, 106, 0.6);
    box-shadow: 0 14px 34px -8px rgba(217, 178, 106, 0.22);
}

.vx_benefit_emerald,
.vx_benefit_grid>.vx_benefit:nth-child(2) {
    background: radial-gradient(120% 120% at 0% 0%, rgba(62, 207, 142, 0.18) 0%, rgba(13, 30, 22, 0.88) 48%, #131316 100%);
    border: 1px solid rgba(62, 207, 142, 0.28);
    box-shadow: 0 4px 20px -8px rgba(0, 0, 0, 0.5);
}

.vx_benefit_emerald:hover,
.vx_benefit_grid>.vx_benefit:nth-child(2):hover {
    border-color: rgba(62, 207, 142, 0.6);
    box-shadow: 0 14px 34px -8px rgba(62, 207, 142, 0.22);
}

.vx_benefit_purple,
.vx_benefit_grid>.vx_benefit:nth-child(3) {
    background: radial-gradient(120% 120% at 0% 0%, rgba(167, 107, 255, 0.18) 0%, rgba(26, 17, 42, 0.88) 48%, #131316 100%);
    border: 1px solid rgba(167, 107, 255, 0.28);
    box-shadow: 0 4px 20px -8px rgba(0, 0, 0, 0.5);
}

.vx_benefit_purple:hover,
.vx_benefit_grid>.vx_benefit:nth-child(3):hover {
    border-color: rgba(167, 107, 255, 0.6);
    box-shadow: 0 14px 34px -8px rgba(167, 107, 255, 0.22);
}

.vx_benefit_blue,
.vx_benefit_grid>.vx_benefit:nth-child(4) {
    background: radial-gradient(120% 120% at 0% 0%, rgba(79, 140, 255, 0.18) 0%, rgba(15, 24, 46, 0.88) 48%, #131316 100%);
    border: 1px solid rgba(79, 140, 255, 0.28);
    box-shadow: 0 4px 20px -8px rgba(0, 0, 0, 0.5);
}

.vx_benefit_blue:hover,
.vx_benefit_grid>.vx_benefit:nth-child(4):hover {
    border-color: rgba(79, 140, 255, 0.6);
    box-shadow: 0 14px 34px -8px rgba(79, 140, 255, 0.22);
}

.vx_benefit_copper,
.vx_benefit_grid>.vx_benefit:nth-child(5) {
    background: radial-gradient(120% 120% at 0% 0%, rgba(243, 138, 94, 0.18) 0%, rgba(36, 19, 16, 0.88) 48%, #131316 100%);
    border: 1px solid rgba(243, 138, 94, 0.28);
    box-shadow: 0 4px 20px -8px rgba(0, 0, 0, 0.5);
}

.vx_benefit_copper:hover,
.vx_benefit_grid>.vx_benefit:nth-child(5):hover {
    border-color: rgba(243, 138, 94, 0.6);
    box-shadow: 0 14px 34px -8px rgba(243, 138, 94, 0.22);
}

.vx_benefit_icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    margin-bottom: 18px;
    border-radius: 16px;
    transition: transform 0.25s ease;
}

.vx_benefit:hover .vx_benefit_icon {
    transform: scale(1.06);
}

.vx_benefit_gold .vx_benefit_icon,
.vx_benefit_grid>.vx_benefit:nth-child(1) .vx_benefit_icon {
    background: rgba(217, 178, 106, 0.14);
    border: 1px solid rgba(217, 178, 106, 0.38);
}

.vx_benefit_emerald .vx_benefit_icon,
.vx_benefit_grid>.vx_benefit:nth-child(2) .vx_benefit_icon {
    background: rgba(62, 207, 142, 0.14);
    border: 1px solid rgba(62, 207, 142, 0.38);
}

.vx_benefit_purple .vx_benefit_icon,
.vx_benefit_grid>.vx_benefit:nth-child(3) .vx_benefit_icon {
    background: rgba(167, 107, 255, 0.14);
    border: 1px solid rgba(167, 107, 255, 0.38);
}

.vx_benefit_blue .vx_benefit_icon,
.vx_benefit_grid>.vx_benefit:nth-child(4) .vx_benefit_icon {
    background: rgba(79, 140, 255, 0.14);
    border: 1px solid rgba(79, 140, 255, 0.38);
}

.vx_benefit_copper .vx_benefit_icon,
.vx_benefit_grid>.vx_benefit:nth-child(5) .vx_benefit_icon {
    background: rgba(243, 138, 94, 0.14);
    border: 1px solid rgba(243, 138, 94, 0.38);
}

.vx_benefit_icon img {
    width: 26px;
    height: 26px
}

.vx_benefit_featured .vx_benefit_icon {
    width: 72px;
    height: 72px;
    margin: 0;
    flex: none
}

.vx_benefit_featured .vx_benefit_icon img {
    width: 36px;
    height: 36px
}

.vx_benefit_title {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 8px;
    color: #fff
}

.vx_benefit_text {
    margin: 0;
    color: #9a9aa3;
    font-size: 14px;
    line-height: 1.6
}

body.light_theme .vx_tier_card {
    background: #fff !important;
    border-color: #e6e6ea;
    border-top-color: var(--vx-c);
    color: #16161a
}

body.light_theme .vx_tier_card:hover,
body.light_theme .vx_tier_card.is-me {
    border-color: var(--vx-c) !important;
    background: #fff !important;
    box-shadow: none !important
}

body.light_theme .vx_tier_name,
body.light_theme .vx_tier_vol strong,
body.light_theme .vx_tier_fee strong,
body.light_theme .vx_benefits_heading,
body.light_theme .vx_benefit_title {
    color: #16161a
}

body.light_theme .vx_benefit_text {
    color: #4e4e58;
}

body.light_theme .vx_tier_fee {
    background: #f4f4f7
}

/* Individual Creative Gradients for Light Theme */
body.light_theme .vx_benefit_gold,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(1) {
    background: linear-gradient(135deg, #fffbf2 0%, #fef3dc 50%, #ffffff 100%);
    border: 1px solid #ebd4a4;
    box-shadow: 0 4px 16px -4px rgba(217, 178, 106, 0.18);
}

body.light_theme .vx_benefit_gold:hover,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(1):hover {
    border-color: #d9b26a;
    box-shadow: 0 12px 28px -6px rgba(217, 178, 106, 0.32);
}

body.light_theme .vx_benefit_gold .vx_benefit_icon,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(1) .vx_benefit_icon {
    background: rgba(217, 178, 106, 0.18);
    border-color: rgba(217, 178, 106, 0.45);
}

body.light_theme .vx_benefit_emerald,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(2) {
    background: linear-gradient(135deg, #f0fbf6 0%, #ddf7eb 50%, #ffffff 100%);
    border: 1px solid #a9e4cc;
    box-shadow: 0 4px 16px -4px rgba(62, 207, 142, 0.18);
}

body.light_theme .vx_benefit_emerald:hover,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(2):hover {
    border-color: #3ecf8e;
    box-shadow: 0 12px 28px -6px rgba(62, 207, 142, 0.32);
}

body.light_theme .vx_benefit_emerald .vx_benefit_icon,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(2) .vx_benefit_icon {
    background: rgba(62, 207, 142, 0.18);
    border-color: rgba(62, 207, 142, 0.45);
}

body.light_theme .vx_benefit_purple,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(3) {
    background: linear-gradient(135deg, #f8f3ff 0%, #ede1fc 50%, #ffffff 100%);
    border: 1px solid #d3baf9;
    box-shadow: 0 4px 16px -4px rgba(167, 107, 255, 0.18);
}

body.light_theme .vx_benefit_purple:hover,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(3):hover {
    border-color: #a76bff;
    box-shadow: 0 12px 28px -6px rgba(167, 107, 255, 0.32);
}

body.light_theme .vx_benefit_purple .vx_benefit_icon,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(3) .vx_benefit_icon {
    background: rgba(167, 107, 255, 0.18);
    border-color: rgba(167, 107, 255, 0.45);
}

body.light_theme .vx_benefit_blue,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(4) {
    background: linear-gradient(135deg, #f1f6ff 0%, #dfeafe 50%, #ffffff 100%);
    border: 1px solid #b5d1fe;
    box-shadow: 0 4px 16px -4px rgba(79, 140, 255, 0.18);
}

body.light_theme .vx_benefit_blue:hover,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(4):hover {
    border-color: #4f8cff;
    box-shadow: 0 12px 28px -6px rgba(79, 140, 255, 0.32);
}

body.light_theme .vx_benefit_blue .vx_benefit_icon,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(4) .vx_benefit_icon {
    background: rgba(79, 140, 255, 0.18);
    border-color: rgba(79, 140, 255, 0.45);
}

body.light_theme .vx_benefit_copper,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(5) {
    background: linear-gradient(135deg, #fff4f0 0%, #fedfd5 50%, #ffffff 100%);
    border: 1px solid #f6beae;
    box-shadow: 0 4px 16px -4px rgba(243, 138, 94, 0.18);
}

body.light_theme .vx_benefit_copper:hover,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(5):hover {
    border-color: #f38a5e;
    box-shadow: 0 12px 28px -6px rgba(243, 138, 94, 0.32);
}

body.light_theme .vx_benefit_copper .vx_benefit_icon,
body.light_theme .vx_benefit_grid>.vx_benefit:nth-child(5) .vx_benefit_icon {
    background: rgba(243, 138, 94, 0.18);
    border-color: rgba(243, 138, 94, 0.45);
}

@media (max-width:991px) {

    .vx_tier_grid,
    .vx_benefit_grid {
        grid-template-columns: repeat(2, minmax(0, 1fr))
    }

    .vx_benefit_featured {
        grid-column: span 2
    }
}

@media (max-width: 767px) {

    .vip_tier_section {
        padding: 40px 0 20px;
    }

    .vx_benefits_heading {
        font-size: 28px;
    }

    .vip button.applybtn,
    .vip a.applybtn {
        font-size: 13px;
        padding: 8px 24px;
    }

    .vip a.vip-hero-secondary {
        font-size: 13px;
        padding: 8px 24px;
    }

    .commingsoon h2 {
        font-size: 36px;
    }

    .vip_features_section h2 {
        font-size: 24px;
    }

    .vip_features_section h3 {
        font-size: 16px;
    }

    .vip_feature_middle_img {
        margin-top: 0px;
    }

    .vip_tier_table_wrapper {
        padding: 4px 20px 10px;
        box-shadow: none;
    }

    .vip_features_section {
        padding: 0px 0px 20px;
    }

    .tier_badge img.table_vector_effect {
        display: none;
    }

    .vip_features_section p {
        font-size: 13px;
    }

    .vip_features_vector {
        min-width: 40px;
        width: 40px;
    }

    .vip_features_cntblock {
        padding-right: 0px;
        margin-top: 10px;
    }

    .vip_feature_card_top {
        position: absolute;
        top: 20px;
        width: 90%;
    }

    .vip_tier_table {
        margin-top: 0;
        border-spacing: 0;
    }

    .vip_tier_table,
    .vip_tier_table tbody,
    .vip_tier_table tr,
    .vip_tier_table td {
        display: block;
        width: 100%;
    }

    .vip_tier_table thead {
        display: none;
    }

    .vip_tier_table tr {
        /* background: #000; */
        /* border: 1px solid #d1aa6761; */
        /* border-radius: 12px; */
        margin-bottom: 0px;
        padding: 0;

    }

    .vip_tier_table tbody tr {
        border-top: none;
    }

    .vip_tier_table td {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;
        text-align: right;
        font-size: 12px;
    }

    .vip_tier_table td:last-child {
        border-bottom: none;
    }

    .vip_tier_table td::before {
        content: attr(data-label);
        font-weight: 500;
        color: #D1AA67;
        text-align: left;
        margin-right: 15px;
    }

    .vip_prime_title {
        font-size: 32px;
    }

    .metric_value {
        font-size: 18px;
        line-height: 24px;
    }

    .vip_prime_title_container {
        padding-top: 40px;
        margin-bottom: 0px;
    }

    .vip_prime_card_left {
        padding: 20px;
        margin: 0px;
        position: relative;
        z-index: 999;
    }

    .metric_unit {
        font-size: 18px;
    }

    .vip_prime_section::before {
        height: 190px;
        background: linear-gradient(0deg, rgb(0 0 0) -10%, rgb(4 4 4) 100%);
    }

    .coin_name {
        font-size: 18px;
    }

    .vip_prime_title {
        color: #fffbf5;
    }

    .vip_prime_card {
        flex-direction: column;
    }

    .vip_prime_card_right {
        width: 100%;
        padding: 10px 20px 24px;
    }

    .vip_tier_title {
        font-size: 22px;
        border-bottom: 2px solid #D1AA67;
    }

    .vip_prime_section {
        padding: 30px 0 20px;
        background-size: 100%;
    }

    .vip_tier_title_container {
        margin-bottom: 20px;
    }

    .vip_features_title_container {
        margin-bottom: 10px;
    }

    .vip_feature_card.vip_feature_card_tall {
        height: 100%;
        padding: 0px;
    }



    .vip_feature_card_heading {
        font-size: 18px;
    }

    .vip_cards_section {
        min-height: 350px;
        padding-top: 30px;
        background-size: 320px;
    }

    .vip_features_grid {
        gap: 18px;
    }

    .desktop_only_cell {
        display: none !important;
    }

    .mobile_more_btn {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        background: none;
        border: none;
        color: #D1AA67;
        margin-left: 10px;
        cursor: pointer;
        padding: 5px;
    }

    .mobile_td_right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
}

@media (max-width: 600px) {

    .commingsoon h2 {
        font-size: 32px;
    }

    .vip_features_grid {
        grid-template-columns: 1fr;
    }

    .vip_feature_card_tall {
        grid-row: span 1;
    }

    .vip_features_title {
        font-size: 24px;
    }

    .vip_hero_img {
        max-width: 190px;
    }

    .vip_feature_card_heading {
        font-size: 18px;
    }

    .vip_feature_card_desc {
        font-size: 14px;
    }

    .vip_hero_section h1 {
        font-size: 22px;
    }

    .vip_hero_section p {
        font-size: 14px;
        padding: 0px;
        margin: 0px;
    }

    .vip button {
        font-size: 14px;
        padding: 7px 24px;
    }

    .vip_cnt_mdp {
        top: 0px;
    }

    .right_metric {
        margin-bottom: 10px;
    }

    .metrics_container {
        gap: 24px;
    }

    .right_title {
        font-size: 16px;
    }

    .right_value {
        font-size: 24px;
    }

    .join_btn {
        padding: 8px 0;
    }

    .vip_features_section {
        padding: 30px 0px 20px;
    }

    .gold_badge {
        font-size: 11px;
    }

    .commingsoon {
        padding: 24px 0px 0px;
    }

    .vip_prime_title_container {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .vip_feature_card_img {
        top: 0px;
    }

    .vip_hero_section:before {
        bottom: -26px;
    }

    .tier_badge img {
        height: 36px;
        left: 29px;
    }

    span.tier_subtext {
        padding-left: 34px;
        left: 0px;
    }

}

@media (max-width:640px) {

    .vx_tier_grid,
    .vx_benefit_grid {
        grid-template-columns: 1fr
    }

    .vx_benefit_featured {
        grid-column: auto;
        flex-direction: column;
        align-items: flex-start
    }

    .vx_benefits_heading {
        font-size: 22px;
        margin: 0 0 20px;
    }

    .vx_benefits {
        padding: 20px 0 40px
    }

    .vip_market_tab {
        padding: 6px 15px;
        font-size: 13px;
    }

    .vip_market_tabs {
        margin: 40px auto 18px;
    }
}

@media (max-width: 330px) {

    .vip_market_tab {
        padding: 5px 13px;
        font-size: 12px;
    }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/VipServices/vip-services.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yDAAwF;IACxF,wBAAwB;IACxB,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,yDAA8F;AAClG;;AAEA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,sEAAsE;AAC1E;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,uFAAuF;IACvF,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,2DAA2D;IAC3D,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;IAC1E,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,wDAAwD;AAC5D;;AAEA;IACI,eAAe;IACf,yEAAyE;IACzE,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,gCAAgC;IAChC,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,+BAA+B;IAC/B,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gFAAgF;IAChF,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAClB,yDAAiF;IACjF,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,iBAAiB;IACjB,yEAAyE;AAC7E;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,8EAA8E;IAC9E,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yEAAyE;IACzE,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mHAAmH;IACnH,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;IAEI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,yDAAgF;IAChF,iBAAiB;IACjB,kCAAkC;IAClC,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,6EAA6E;AACjF;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;;AAGA,yBAAyB;AACzB;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;;IAEI;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;AAEJ;;AAEA;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;;IAGA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;;AAIJ;;;AAGA,wEAAwE;AACxE;;IAEI;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,QAAQ;IACZ;;;IAGA;QACI,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,QAAQ;IACZ;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,8BAA8B;QAC9B,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;;OAEG;;IAEH;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;;;IAIA;QACI,YAAY;IAChB;AACJ;;;;AAIA,0BAA0B;AAC1B;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI;QACI,0FAA0F;IAC9F;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,yFAAyF;IACzF,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,0FAA0F;AAC9F;;AAEA;IACI;QACI,mFAAmF;IACvF;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yFAAyF;AAC7F;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;;;;;;;GAQG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,oDAAoD;IACpD,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;QACR,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,aAAa;QACb,eAAe;QACf,mBAAmB;QACnB,2BAA2B;QAC3B,QAAQ;QACR,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,kFAAkF;AAClF;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gEAAgE;IAChE,yBAAyB;IACzB,iCAAiC;IACjC,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT;AACJ;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,0GAA0G;IAC1G,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,iDAAiD;AACjD;;IAEI,uHAAuH;IACvH,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;;IAEI,sCAAsC;IACtC,sDAAsD;AAC1D;;AAEA;;IAEI,sHAAsH;IACtH,0CAA0C;IAC1C,8CAA8C;AAClD;;AAEA;;IAEI,qCAAqC;IACrC,qDAAqD;AACzD;;AAEA;;IAEI,uHAAuH;IACvH,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;;IAEI,sCAAsC;IACtC,sDAAsD;AAC1D;;AAEA;;IAEI,sHAAsH;IACtH,0CAA0C;IAC1C,8CAA8C;AAClD;;AAEA;;IAEI,qCAAqC;IACrC,qDAAqD;AACzD;;AAEA;;IAEI,sHAAsH;IACtH,0CAA0C;IAC1C,8CAA8C;AAClD;;AAEA;;IAEI,qCAAqC;IACrC,qDAAqD;AACzD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;;IAEI,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;;IAEI,qCAAqC;IACrC,2CAA2C;AAC/C;;AAEA;;IAEI,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;;IAEI,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,6BAA6B;IAC7B;AACJ;;AAEA;;IAEI,oCAAoC;IACpC,2BAA2B;IAC3B;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA,kDAAkD;AAClD;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;;IAEI,qBAAqB;IACrB,sDAAsD;AAC1D;;AAEA;;IAEI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;;IAEI,qBAAqB;IACrB,qDAAqD;AACzD;;AAEA;;IAEI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,qDAAqD;AACzD;;AAEA;;IAEI,qBAAqB;IACrB,sDAAsD;AAC1D;;AAEA;;IAEI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;;IAEI,qBAAqB;IACrB,qDAAqD;AACzD;;AAEA;;IAEI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;;IAEI,0EAA0E;IAC1E,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;;IAEI,qBAAqB;IACrB,qDAAqD;AACzD;;AAEA;;IAEI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,UAAU;IACd;;IAEA;QACI,aAAa;QACb,iBAAiB;IACrB;;IAEA;;;;QAII,cAAc;QACd,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,iCAAiC;QACjC,yBAAyB;QACzB,kBAAkB;QAClB,UAAU;;IAEd;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mEAAmE;IACvE;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,gCAAgC;IACpC;;IAEA;QACI,oBAAoB;QACpB,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;;;IAIA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,+BAA+B;QAC/B,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,YAAY;QACZ,cAAc;QACd,iBAAiB;QACjB,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,yBAAyB;IAC7B;AACJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;AAEJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;QACtB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;;IAEI;QACI,iBAAiB;QACjB,eAAe;IACnB;;AAEJ","sourcesContent":[".vip_hero_section {\n    width: 100%;\n    text-align: center;\n    background-color: #181a20;\n    min-height: 816px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    color: #fff;\n    background-image: url(../../../../public/images/vip-services-img/vip_servies_herobg.jpg);\n    background-size: contain;\n    background-position: center top;\n    background-repeat: no-repeat;\n}\n\nbody.light_theme .vip_hero_section {\n    background-image: url(../../../../public/images/vip-services-img/vip_servies_herobg_light.jpg);\n}\n\n.vip_hero_section:before {\n    width: 100%;\n    height: 150px;\n    content: \"\";\n    position: absolute;\n    /* top: 0px; */\n    bottom: 0px;\n    background: linear-gradient(0deg, #181A20 -10%, rgba(4, 4, 4, 0) 100%);\n}\n\n.vip_hero_img {\n    max-width: 530px;\n    margin: 0 auto;\n}\n\n.vip_hero_section h1 {\n    background: linear-gradient(270deg, #FFF3D1 0%, #ffeed1 30%, #D1AA67 70%, #A67C33 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    font-weight: 800;\n    letter-spacing: 1.2px;\n    margin-top: 24px;\n    display: inline-block;\n    filter: drop-shadow(0px 4px 15px rgba(209, 170, 103, 0.35));\n    transition: all 0.3s ease;\n}\n\nbody.light_theme .vip_hero_section h1 {\n    background: linear-gradient(135deg, #C49A4C 0%, #9D7A3F 40%, #6E511E 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    filter: drop-shadow(0px 2px 8px rgba(157, 122, 63, 0.2));\n}\n\n.vip_hero_section p {\n    font-size: 24px;\n    background: linear-gradient(90deg, #E6C285 0%, #F5D186 50%, #E6C285 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    padding-top: 8px;\n    font-weight: 500;\n    letter-spacing: 0.5px;\n}\n\n.vip_cnt_mdp {\n    margin-top: 84px;\n    position: relative;\n    z-index: 999;\n}\n\n.vip {\n    justify-content: center;\n    padding-top: 15px;\n    gap: 24px;\n}\n\n.vip button {\n    font-size: 20px;\n    padding: 18px 48px;\n    border: 1px solid #D7B46A;\n    background-color: transparent;\n    color: #F5D186;\n    border-radius: 100px;\n    font-weight: 400;\n}\n\n.vip button.applybtn,\n.vip a.applybtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    padding: 18px 48px;\n    border: 1px solid #D1AA67;\n    border-radius: 100px;\n    font-weight: 400;\n    background: #D1AA67;\n    color: #000;\n    text-decoration: none;\n}\n\n.vip a.vip-hero-secondary {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    padding: 18px 48px;\n    border: 1px solid #D7B46A;\n    background-color: transparent;\n    color: #F5D186;\n    border-radius: 100px;\n    font-weight: 400;\n    text-decoration: none;\n}\n\n.vip a.applybtn:hover,\n.vip a.vip-hero-secondary:hover {\n    opacity: 0.92;\n    color: #000;\n}\n\n.vip a.vip-hero-secondary:hover {\n    color: #F5D186;\n}\n\n/* VIP Tier Section Styles */\n.vip_tier_section {\n    background-color: #181A20;\n    padding: 100px 0 100px;\n    color: #fff;\n}\n\n.vip_tier_content {\n    width: 100%;\n}\n\n.vip_tier_title_container {\n    text-align: center;\n    margin-bottom: 40px;\n}\n\n.vip_tier_title {\n    font-size: 40px;\n    font-weight: 600;\n    color: #fff;\n    display: inline-block;\n    border-bottom: 4px solid #D1AA67;\n    padding-bottom: 4px;\n    letter-spacing: 0.5px;\n}\n\n.vip_tier_table_wrapper {\n    max-width: 1200px;\n    margin: 0 auto;\n    background: #1b1d24;\n    /* border: 1px solid #0D0D0D; */\n    border-radius: 12px 12px 0px 0px;\n    overflow: hidden;\n}\n\n.vip_tier_table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0 5px;\n    margin-top: -5px;\n    text-align: left;\n}\n\n.vip_tier_table th {\n    background: linear-gradient(0deg, rgba(2, 2, 2, 1) 0%, rgba(19, 19, 19, 1) 100%);\n    color: #D1AA67;\n    font-size: 20px;\n    font-weight: 500;\n    border-top: 2px solid #D1AA67;\n    padding: 22px 24px;\n}\n\n.vip_tier_table td td.first_td {\n    padding: 0px;\n}\n\n.tier_badge img.table_vector_effect {\n    position: absolute;\n    left: 0px;\n    top: 0px;\n    bottom: 0px;\n    /* width: 228px; */\n    height: 100%;\n}\n\n.vip_tier_table tbody tr {\n    /* margin-top: 20px; */\n    position: relative;\n}\n\n.vip_tier_table td {\n    padding: 10px 24px;\n    font-size: 18px;\n    font-weight: 500;\n    color: #F7F8F9;\n    border-bottom: none;\n    vertical-align: middle;\n}\n\nbody.light_theme .vip_tier_table td {\n    border-bottom: 1px solid #0D0D0D;\n}\n\n.vip_tier_table td.first_td {\n    min-width: 203px;\n}\n\n.vip_tier_table tr:last-child td {\n    border-bottom: none;\n}\n\n.tier_badge {\n    display: flex;\n    align-items: center;\n    max-width: 112px;\n}\n\n.tier_badge img {\n    height: 48px;\n    width: auto;\n    object-fit: contain;\n}\n\n/* VIP Prime Section Styles */\n.vip_prime_section {\n    background-color: #000000;\n    padding: 60px 0 50px;\n    color: #fff;\n    position: relative;\n    background-image: url(../../../../public/images/vip-services-img/vip_primebg.jpg);\n    background-size: 1210px;\n    background-position: center top;\n    background-repeat: no-repeat;\n}\n\n.vip_prime_section::before {\n    width: 100%;\n    height: 420px;\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    /* bottom: 0px; */\n    background: linear-gradient(0deg, rgb(0 0 0) -10%, rgb(4 4 4 / 45%) 100%);\n}\n\n.vip_prime_title_container {\n    padding-top: 120px;\n    padding-bottom: 30px;\n    text-align: center;\n    margin-bottom: 50px;\n}\n\nimg.vip_heading_vector {\n    position: absolute;\n    top: -60px;\n    margin: 0 auto;\n    max-width: 370px;\n    left: 0px;\n    right: 0px;\n}\n\nspan.tier_subtext {\n    color: #ffffff;\n    text-transform: uppercase;\n    font-weight: 600;\n    padding-left: 45px;\n    font-size: 24px;\n    position: relative;\n    left: -28px;\n}\n\n.tier_badge img {\n    position: relative;\n    z-index: 666;\n}\n\n.vip_prime_title {\n    font-size: 60px;\n    font-weight: 600;\n    color: #edd3a5;\n    display: inline-block;\n    position: relative;\n    line-height: 110%;\n    letter-spacing: 0.5px;\n    max-width: 160px;\n}\n\n.vip_prime_section .container {\n    position: relative;\n}\n\n.vip_prime_cards_container {\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.vip_prime_card {\n    display: flex;\n    background: #040404;\n    border: 1px solid #d1aa6761;\n    border-radius: 20px;\n    overflow: hidden;\n    margin-bottom: 24px;\n    transition: all 0.3s ease;\n    position: relative;\n}\n\nimg.vip_right_vector {\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    max-width: 486px;\n    height: 100%;\n}\n\n.vip_prime_card.gempoolprime .join_btn {\n    background: #3FD174;\n}\n\n.vip_prime_card.gempoolprime .right_value {\n    color: #3FD174;\n}\n\n.vip_prime_card.mining_prime .join_btn {\n    background: #986FF5;\n}\n\n.vip_prime_card.mining_prime .right_value {\n    color: #986FF5\n}\n\n.vip_prime_card:hover {\n    border-color: rgba(209, 170, 103, 0.6);\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.8), 0 0 20px rgba(209, 170, 103, 0.15);\n    transform: translateY(-8px);\n}\n\n.vip_prime_card_left {\n    flex: 1 1;\n    padding: 32px;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin: 32px;\n}\n\n.vip_prime_card_right {\n    width: 250px;\n    padding: 30px 0px;\n    display: flex;\n    flex-direction: column;\n    margin-right: 80px;\n    justify-content: center;\n}\n\n.coin_info {\n    display: flex;\n    align-items: center;\n    margin-bottom: 24px;\n    gap: 12px;\n}\n\n.vip_prime_card .coin_icon {\n    height: 40px;\n    width: 40px;\n    object-fit: contain;\n    top: 0px;\n    margin: 0px;\n    border: none;\n    background-color: transparent;\n}\n\nbody.light_theme .benifitsbtn.one .benifits_vector {\n    filter: invert(1);\n}\n\n.coin_name {\n    font-size: 24px;\n    font-weight: 500;\n    color: #fff;\n}\n\n.vip_prime_card.gempoolprime {\n    border-color: #072914;\n}\n\n.vip_prime_card.mining_prime {\n    border-color: #221232;\n}\n\n.coin_subname {\n    font-size: 14px;\n    color: #888;\n    font-weight: 400;\n}\n\n.coin_desc {\n    font-size: 14px;\n    color: #888;\n    margin-left: 12px;\n    font-weight: 400;\n}\n\n.metrics_container {\n    display: flex;\n    gap: 80px;\n}\n\n.metric_col {\n    display: flex;\n    flex-direction: column;\n}\n\n.metric_label {\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 8px;\n}\n\n.metric_value {\n    font-size: 28px;\n    font-weight: 600;\n    color: #fff;\n    display: flex;\n    align-items: center;\n}\n\n.metric_unit {\n    font-size: 20px;\n    font-weight: 500;\n    color: #fff;\n    margin-left: 6px;\n}\n\nbody.light_theme .vip_hero_section p {\n    background: linear-gradient(90deg, #E6C285 0%, #b78d38 50%, #E6C285 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.gold_badge {\n    background: #2C2819;\n    color: #FFC400;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 3px 8px;\n    border-radius: 4px;\n    margin-left: 12px;\n}\n\n.special_boost_text {\n    font-size: 14px;\n    color: #FFC400;\n    margin-top: 16px;\n    font-weight: 500;\n}\n\n/* Right Side Styles */\n.right_title_row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 14px;\n    position: relative;\n    z-index: 666;\n}\n\n.right_title {\n    font-size: 20px;\n    font-weight: 500;\n    color: #F3F3F3;\n}\n\n.vip_pill_badge {\n    background: linear-gradient(90deg, rgba(208, 170, 0, 1) 0%, rgba(255, 214, 109, 1) 50%, rgba(224, 162, 31, 1) 100%);\n    color: #000;\n    font-size: 11px;\n    font-weight: 500;\n    padding: 3px 6px;\n    border-radius: 4px;\n    margin-left: 8px;\n    text-transform: uppercase;\n}\n\n.right_metric {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 24px;\n    position: relative;\n    z-index: 666;\n}\n\n.right_label {\n    font-size: 13px;\n    color: #888;\n    margin-bottom: 6px;\n}\n\n.right_value {\n    font-size: 36px;\n    font-weight: 500;\n    color: #F5D186;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n}\n\n.arrow_up,\n.arrow_down {\n    margin-right: 6px;\n    font-size: 24px;\n    vertical-align: middle;\n}\n\n.join_btn {\n    width: 100%;\n    background: #D1AA67;\n    color: #000;\n    font-size: 15px;\n    position: relative;\n    z-index: 666;\n    font-weight: 600;\n    padding: 10px 0;\n    border: none;\n    border-radius: 100px;\n    cursor: pointer;\n    transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n.join_btn:hover {\n    transform: translateY(-2px);\n    opacity: 0.95;\n}\n\n.vip_cards_section {\n    width: 100%;\n    background-image: url(../../../../public/images/vip-services-img/vip_cardbg.png);\n    min-height: 700px;\n    background-position: bottom center;\n    background-repeat: no-repeat;\n    background-color: #181A20;\n    padding-top: 155px;\n    position: relative;\n}\n\n.vip_cards_section::before {\n    width: 100%;\n    height: 100%;\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    bottom: 0px;\n    background: linear-gradient(0deg, rgba(4, 4, 4, 1) 0%, rgba(4, 4, 4, 0) 100%);\n}\n\n.vip_cards_img {\n    max-width: 384px;\n    margin: 0 auto;\n    position: relative;\n    z-index: 666;\n}\n\n.vip_features_section {\n    width: 100%;\n    display: block;\n    text-align: center;\n    background-color: #181A20;\n    color: #fff;\n    padding: 30px 0px 140px;\n}\n\n.vip_features_section h2 {\n    font-size: 40px;\n    font-weight: 600;\n}\n\n.vip_cnt_block {\n    width: 100%;\n    display: flex;\n    text-align: left;\n    gap: 24px;\n    align-items: center;\n    position: relative;\n}\n\n.vip_cnt_block.firstblock {\n    top: -20px;\n    left: 45px;\n}\n\n.vip_cnt_block.lastblock {\n    top: 29px;\n    left: 60px;\n}\n\n.vip_features_section h3 {\n    font-size: 24px;\n    font-weight: 600;\n}\n\n.vip_features_section h3 span {\n    color: #D1AA67;\n}\n\n.vip_features_section p {\n    font-size: 15px;\n    color: #f3f3f399;\n}\n\n.cnt_vip_bl {\n    max-width: 280px;\n}\n\n.vip_features_vector {\n    min-width: 90px;\n}\n\n.vip_features_cntblock.vip_rightside .vip_cnt_block {\n    flex-direction: row-reverse;\n    padding-left: 15px;\n}\n\n.vip_features_cntblock.vip_rightside .vip_cnt_block.firstblock {\n    left: -45px;\n}\n\n.vip_features_cntblock.vip_rightside .vip_cnt_block.lastblock {\n    left: -60px;\n}\n\n\n.vip_features_cntblock {\n    width: 375px;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 34px;\n    margin-top: 88px;\n    padding-right: 10px;\n}\n\n.vip_features_midbl {\n    width: 670px;\n    max-width: 100%;\n    position: relative;\n}\n\n.vip_features_block {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    margin-top: 48px;\n}\n\n.vip_feature_middle_img {\n    width: 520px;\n    margin: 0 auto;\n    max-width: 100%;\n    /* position: relative; */\n    /* z-index: 999; */\n    margin-top: 70px;\n}\n\nimg.vip_effect_middle {\n    position: absolute;\n    left: 0px;\n    top: 0px;\n}\n\n\n/* Mobile Details Modal */\n.mobile_more_btn {\n    display: none;\n}\n\n.vip_tier_modal_overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgb(0 0 0 / 83%);\n    display: flex;\n    align-items: end;\n    justify-content: center;\n    z-index: 99999999;\n    padding: 0px;\n}\n\n.vip_tier_modal_content {\n    background: #505050d1;\n    border-radius: 16px 16px 0px 0px;\n    width: 100%;\n    max-width: 400px;\n    padding: 24px;\n    box-shadow: 0 10px 40px rgb(0 0 0 / 22%);\n    position: relative;\n}\n\n.vip_tier_modal_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}\n\n.vip_tier_modal_header h3 {\n    color: #ffffff;\n    margin: 0;\n    font-size: 20px;\n}\n\n.close_modal_btn {\n    background: none;\n    border: none;\n    color: #fff;\n    padding: 0px;\n    font-size: 28px;\n    cursor: pointer;\n    line-height: 1;\n}\n\n.modal_detail_row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.modal_detail_row:last-child {\n    border-bottom: none;\n}\n\n.modal_detail_label {\n    color: #d8d8d8;\n    font-size: 14px;\n}\n\n.modal_detail_value {\n    color: #fff;\n    font-size: 15px;\n    font-weight: 500;\n    text-align: right;\n}\n\n.modal_tier_badge {\n    margin: 0;\n}\n\n.benifitsbtn {\n    display: inline-flex;\n    align-items: center;\n    padding: 12px 24px;\n    border-radius: 6px;\n    font-weight: 500;\n    gap: 12px;\n    color: #fff;\n    background-color: #121212;\n    width: 280px;\n    border: 1px solid transparent;\n    border-right-width: 5px;\n    font-size: 16px;\n    justify-content: flex-start;\n    transition: all 0.3s ease;\n}\n\n.benifitsbtn.one {\n    border-color: rgba(160, 160, 160, 0.15);\n    border-right-color: #a0a0a0;\n    box-shadow: 0 0 15px rgba(160, 160, 160, 0.05);\n}\n\n.benifitsbtn.two {\n    border-color: rgba(230, 138, 0, 0.15);\n    border-right-color: #e68a00;\n    box-shadow: 0 0 15px rgba(230, 138, 0, 0.05);\n}\n\n.benifitsbtn.three {\n    border-color: rgba(63, 209, 116, 0.15);\n    border-right-color: #3FD174;\n    box-shadow: 0 0 15px rgba(63, 209, 116, 0.05);\n}\n\n.benifitsbtn.four {\n    border-color: rgba(41, 121, 255, 0.15);\n    border-right-color: #2979ff;\n    box-shadow: 0 0 15px rgba(41, 121, 255, 0.05);\n}\n\n.benifitsbtn.five {\n    border-color: rgba(168, 85, 247, 0.15);\n    border-right-color: #a855f7;\n    box-shadow: 0 0 15px rgba(168, 85, 247, 0.05);\n}\n\n.commingsoon {\n    width: 100%;\n    padding: 70px 0px 10px;\n    text-align: center;\n    background-color: #181A20;\n}\n\n.commingsoon h2 {\n    font-size: 90px;\n    background: linear-gradient(135deg, #e6c285, #905920);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    display: inline-block;\n}\n\n@media (max-width: 1550px) {\n\n    .vip_hero_img {\n        max-width: 420px;\n    }\n\n    .vip_hero_section {\n        min-height: 670px;\n    }\n\n    .vip_tier_section {\n        padding: 150px 0 100px;\n    }\n\n    .vip_cnt_mdp {\n        top: 40px;\n    }\n\n    .vip_feature_middle_img {\n        width: 450px;\n    }\n\n}\n\n@media (max-width: 1200px) {\n\n    .vip_feature_middle_img {\n        width: 200px;\n    }\n\n    .vip_cnt_mdp {\n        margin-top: 0px;\n    }\n\n    .vip_features_vector {\n        min-width: 70px;\n    }\n\n    .vip_features_section h3 {\n        font-size: 20px;\n    }\n\n    .vip_features_section p {\n        font-size: 14px;\n    }\n\n    .vip_features_cntblock {\n        gap: 20px;\n        margin-top: 32px;\n    }\n\n    .vip_cnt_block.firstblock {\n        top: 0px;\n        left: 15px;\n    }\n\n    .vip_cnt_block.lastblock {\n        top: 0px;\n        left: 20px;\n    }\n\n    .vip_features_section {\n        padding: 30px 0px 30px;\n    }\n\n    .vip_features_section h2 {\n        font-size: 32px;\n    }\n\n    .vip_prime_card_left {\n        padding: 0px;\n    }\n\n    .metric_value {\n        font-size: 22px;\n    }\n\n    .metrics_container {\n        gap: 40px;\n    }\n\n    .benifitsbtn {\n        padding: 12px 10px;\n        width: 190px;\n        gap: 6px;\n        font-size: 13px;\n    }\n\n    .vip_features_midbl {\n        width: 420px;\n    }\n\n\n    .vip_hero_section {\n        min-height: 550px;\n    }\n\n    .vip_hero_img {\n        max-width: 300px;\n    }\n\n    .vip_cnt_mdp {\n        top: 70px;\n    }\n\n    .vip_tier_title {\n        font-size: 32px;\n    }\n\n\n    .vip_prime_title {\n        font-size: 40px;\n    }\n\n    .vip_tier_table th {\n        font-size: 16px;\n    }\n\n    .vip_tier_table td {\n        font-size: 15px;\n    }\n\n\n\n}\n\n\n/* ===================== VIP Features Responsive ===================== */\n@media (max-width: 991px) {\n\n    .vip_features_block {\n        flex-direction: column;\n        margin-top: 20px;\n    }\n\n    span.tier_subtext {\n        font-size: 18px;\n        top: 3px;\n    }\n\n\n    .tier_badge img.table_vector_effect {\n        height: 55px;\n        top: -2px;\n    }\n\n    .vip_tier_table td.first_td {\n        min-width: 152px;\n    }\n\n    .tier_badge img {\n        height: 32px;\n        top: 3px;\n    }\n\n    .vip_tier_table td {\n        padding: 6px 14px;\n        font-size: 13px;\n    }\n\n    .vip_tier_table th {\n        font-size: 13px;\n        padding: 14px 12px;\n    }\n\n    .metric_value {\n        font-size: 20px;\n        flex-direction: column;\n        align-items: start;\n    }\n\n    .gold_badge {\n        font-size: 12px;\n        margin-left: 0px;\n    }\n\n    .metric_unit {\n        margin-left: 0px;\n    }\n\n    .vip_features_cntblock {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .vip_cnt_block.firstblock {\n        left: 0px;\n    }\n\n    .vip_cnt_block.lastblock {\n        top: 0px;\n        left: 0px;\n    }\n\n    .vip_features_vector {\n        min-width: 70px;\n        width: 70px;\n    }\n\n    img.vip_effect_middle {\n        display: none;\n    }\n\n    .vip_feature_middle_img {\n        width: 300px;\n        margin-top: 20px;\n        order: 1;\n    }\n\n    img.vip_heading_vector {\n        top: -30px;\n    }\n\n    .vip_features_cntblock.vip_rightside .vip_cnt_block.firstblock {\n        left: 0px;\n        padding: 0px;\n    }\n\n    .vip_cnt_block {\n        justify-content: space-between;\n        padding: 0px;\n    }\n\n    .vip_features_cntblock.vip_rightside .vip_cnt_block {\n        padding-left: 0px;\n    }\n\n    .vip_features_cntblock.vip_rightside .vip_cnt_block.lastblock {\n        left: 0px;\n    }\n\n    .cnt_vip_bl {\n        max-width: 100%;\n        width: 100%;\n    }\n\n    .vip_features_cntblock.vip_rightside .vip_cnt_block {\n        flex-direction: row;\n    }\n\n    .vip_hero_section {\n        min-height: 100%;\n        padding: 40px 0px;\n    }\n\n    .vip_cnt_mdp {\n        top: 0px;\n        margin-top: 0px;\n    }\n\n    .vip_tier_section {\n        padding: 40px 0 50px;\n    }\n\n    .vip_prime_section {\n        padding: 30px 0 50px;\n    }\n\n    .vip_tier_title {\n        font-size: 26px;\n    }\n\n    .commingsoon h2 {\n        font-size: 60px;\n    }\n\n\n    .vip_cards_section {\n        min-height: 620px;\n        padding-top: 80px;\n    }\n\n    /* .vip_feature_card_img {\n        top: -80px;\n    } */\n\n    .vip_hero_section h1 {\n        font-size: 24px;\n        margin-top: 0px;\n    }\n\n    .vip button {\n        font-size: 16px;\n        padding: 12px 48px;\n    }\n\n    .vip_hero_section p {\n        font-size: 20px;\n    }\n\n\n\n    .vip_prime_card .coin_icon {\n        padding: 0px;\n    }\n}\n\n\n\n/* Light Theme Overrides */\nbody.light_theme .vip_hero_section {\n    background-color: #ffffff;\n    color: #000000;\n}\n\nbody.light_theme .vip_hero_section:before {\n    background: linear-gradient(0deg, rgb(255, 255, 255) -10%, rgba(255, 255, 255, 0) 100%);\n}\n\n@media (max-width: 600px) {\n    body.light_theme .vip_hero_section:before {\n        background: linear-gradient(0deg, rgb(255, 255, 255) -10%, rgba(255, 255, 255, 0.89) 100%);\n    }\n\n    .vip_tier_section {\n        padding: 30px 0 20px;\n    }\n}\n\nbody.light_theme .vip_hero_section p {\n    color: #333333;\n}\n\nbody.light_theme .vip_tier_section {\n    background-color: #fcfcfc;\n    color: #000000;\n}\n\nbody.light_theme .vip_tier_title {\n    color: #000000;\n}\n\nbody.light_theme .vip_tier_table_wrapper {\n    background: #ffffff;\n    border: 1px solid #eaeaea;\n}\n\nbody.light_theme .vip_tier_table th {\n    background: linear-gradient(0deg, rgba(245, 245, 245, 1) 0%, rgba(255, 255, 255, 1) 100%);\n    color: #000000;\n    border-top: 2px solid #D1AA67;\n}\n\nbody.light_theme .vip_tier_table tbody tr {\n    /* spacing handled by border-spacing */\n}\n\nbody.light_theme .vip_tier_table td {\n    color: #000000;\n    border-bottom: none;\n}\n\nbody.light_theme .vip_prime_section {\n    background-color: #ffffff;\n    color: #000000;\n}\n\nbody.light_theme .vip_prime_section::before {\n    background: linear-gradient(0deg, rgb(255, 255, 255) -10%, rgba(255, 255, 255, 0.45) 100%);\n}\n\n@media (max-width: 1550px) {\n    body.light_theme .vip_prime_section::before {\n        background: linear-gradient(0deg, rgb(255, 255, 255) -10%, rgb(255, 255, 255) 100%);\n    }\n}\n\nbody.light_theme span.tier_subtext {\n    color: #000000;\n}\n\nbody.light_theme .vip_prime_card {\n    background: #ffffff;\n    border-color: #eaeaea;\n}\n\nbody.light_theme .vip_prime_card.gempoolprime {\n    border-color: #e5f5eb;\n}\n\nbody.light_theme .vip_prime_card.mining_prime {\n    border-color: #f2ebff;\n}\n\nbody.light_theme .coin_name {\n    color: #000000;\n}\n\nbody.light_theme .metric_value {\n    color: #000000;\n}\n\nbody.light_theme .metric_unit {\n    color: #000000;\n}\n\nbody.light_theme .right_title {\n    color: #000000;\n}\n\nbody.light_theme .vip_cards_section {\n    background-color: #fcfcfc;\n}\n\nbody.light_theme .vip_cards_section::before {\n    background: linear-gradient(0deg, rgba(252, 252, 252, 1) 0%, rgba(252, 252, 252, 0) 100%);\n}\n\nbody.light_theme .vip_features_section {\n    background-color: #ffffff;\n    color: #000000;\n}\n\nbody.light_theme .vip_features_section p {\n    color: #666666;\n}\n\nbody.light_theme .commingsoon {\n    background-color: #fcfcfc;\n}\n\nbody.light_theme .benifitsbtn {\n    background-color: #ffffff;\n    color: #000000;\n}\n\nbody.light_theme .vip_tier_modal_content {\n    background: #ffffff;\n}\n\nbody.light_theme .vip_tier_modal_header h3 {\n    color: #000000;\n}\n\nbody.light_theme .close_modal_btn {\n    color: #000000;\n}\n\nbody.light_theme .modal_detail_row {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\nbody.light_theme .modal_detail_label {\n    color: #666666;\n}\n\nbody.light_theme .modal_detail_value {\n    color: #000000;\n}\n\n.vip_tier_lead {\n    max-width: 720px;\n    margin: 16px auto 0;\n    color: #cfcfcf;\n    font-size: 16px;\n    line-height: 1.5;\n}\n\n.vip_progress_grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 16px;\n    max-width: 100%;\n    margin: 36px auto 12px;\n}\n\n.vip_progress_card {\n    position: relative;\n    background: #1b1d24;\n    border: 1px solid rgba(209, 170, 103, 0.35);\n    border-radius: 16px;\n    padding: 24px;\n}\n\n/* .vip_progress_card::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: linear-gradient(90deg, #A67C33, #F5D186, #A67C33);\n} */\n\n.vip_progress_head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 14px;\n}\n\n.vip_progress_market {\n    font-size: 18px;\n    font-weight: 600;\n    color: #fff;\n}\n\n.vip_progress_tier {\n    flex-shrink: 0;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.4px;\n    color: #1a1408;\n    background: linear-gradient(90deg, #F5D186, #D1AA67);\n    border-radius: 100px;\n    padding: 4px 10px;\n    white-space: nowrap;\n}\n\n.vip_progress_track {\n    height: 8px;\n    border-radius: 100px;\n    background: #2c303a;\n    overflow: hidden;\n}\n\n.vip_progress_fill {\n    height: 100%;\n    border-radius: 100px;\n    background: linear-gradient(90deg, #8d6a2f, #F5D186);\n}\n\n.vip_progress_scale {\n    display: flex;\n    justify-content: space-between;\n    gap: 8px;\n    margin-top: 8px;\n    font-size: 12px;\n    color: #b5b5b5;\n}\n\n.vip_progress_scale span:last-child {\n    text-align: right;\n}\n\n.vip_progress_remain {\n    margin: 12px 0 0;\n    font-size: 14px;\n    font-weight: 400;\n    color: #fcfcfc;\n}\n\nbody.light_theme .vip_progress_remain {\n    color: #5c5c5c;\n}\n\n.vip_progress_login {\n    display: inline-flex;\n    margin-top: 12px;\n    color: #D1AA67;\n    /* background: #D1AA67; */\n    /* border-radius: 100px; */\n    /* padding: 8px 16px; */\n    gap: 4px;\n    font-size: 14px;\n    font-weight: 600;\n    text-decoration: none;\n}\n\n.vip_progress_fees {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    margin: 6px 0 0;\n    font-size: 13px;\n    line-height: 1.45;\n    color: #d5d5d5;\n}\n\n.vip_progress_note,\n.vip_market_note {\n    max-width: 1200px;\n    margin: 0 auto 22px;\n    text-align: center;\n    color: #9a9a9a;\n    font-size: 13px;\n}\n\n.vip_market_note {\n    margin-top: 16px;\n    margin-bottom: 0;\n    line-height: 1.5;\n}\n\n.vip_market_tabs {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 10px;\n    max-width: 1200px;\n    margin: 100px auto 18px;\n}\n\n.vip_market_tab {\n    border: 1px solid #D7B46A;\n    background: transparent;\n    color: #F5D186;\n    border-radius: 100px;\n    padding: 10px 22px;\n    font-size: 15px;\n    font-weight: 500;\n    cursor: pointer;\n}\n\n.vip_market_tab.is-active {\n    background: #D1AA67;\n    border-color: #D1AA67;\n    color: #111;\n}\n\n.vip_tier_table .tier_badge {\n    max-width: 160px;\n}\n\n.vip_tier_table span.tier_subtext {\n    font-size: 15px;\n    letter-spacing: 0.2px;\n}\n\n.vip_tier_table tbody tr.is-current td {\n    background: rgba(209, 170, 103, 0.1);\n}\n\n.vip_you_tag {\n    display: inline-flex;\n    margin-left: 8px;\n    padding: 2px 8px;\n    border-radius: 100px;\n    border: 1px solid #D1AA67;\n    color: #F5D186;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.3px;\n    vertical-align: middle;\n}\n\n.benifitsbtn.six {\n    border-color: rgba(209, 170, 103, 0.2);\n    border-right-color: #D1AA67;\n    box-shadow: 0 0 15px rgba(209, 170, 103, 0.08);\n}\n\nbody.light_theme .vip_tier_lead {\n    color: #555;\n}\n\nbody.light_theme .vip_progress_card {\n    background: #fff;\n    border-color: rgba(209, 170, 103, 0.45);\n}\n\nbody.light_theme .vip_progress_market,\nbody.light_theme .vip_progress_fees {\n    color: #1a1a1a;\n}\n\nbody.light_theme .vip_progress_track {\n    background: #efe8da;\n}\n\nbody.light_theme .vip_progress_scale,\nbody.light_theme .vip_progress_note,\nbody.light_theme .vip_market_note {\n    color: #666;\n}\n\nbody.light_theme .vip_market_tab {\n    color: #8a6a32;\n}\n\nbody.light_theme .vip_market_tab.is-active {\n    color: #111;\n}\n\nbody.light_theme .vip_tier_table tbody tr.is-current td {\n    background: rgba(209, 170, 103, 0.16);\n}\n\nbody.light_theme .vip_you_tag {\n    color: #8a6a32;\n}\n\n@media (max-width: 767px) {\n    .vip_tier_table_wrapper {\n        overflow: visible;\n    }\n\n    .vip_tier_table td {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 4px;\n        text-align: left;\n    }\n\n    .vip_tier_table td::before {\n        margin-right: 0;\n    }\n\n    .mobile_td_right {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .vol_text {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: flex-start;\n        gap: 6px;\n        min-width: 0;\n    }\n\n    .vip_you_tag {\n        margin-left: 0;\n    }\n\n    .vip_tier_table td.desktop_only_cell {\n        display: flex !important;\n    }\n\n    .benifitsbtn {\n        width: auto;\n        max-width: 100%;\n    }\n}\n\n@media (max-width: 991px) {\n    .vip_progress_grid {\n        grid-template-columns: 1fr;\n    }\n\n    .vip_tier_lead {\n        font-size: 14px;\n    }\n\n    .vip_progress_fees {\n        font-size: 12px;\n    }\n}\n\n/* ===== VIP page redesign: unique vx_ classes only (no element selectors) ===== */\n.vx_tier_grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 20px;\n    margin-top: 32px\n}\n\n.vx_tier_card {\n    --vx-c: #b5b5bd;\n    position: relative;\n    background: linear-gradient(160deg, #17171b, #101012) !important;\n    border: 2px solid #26262b;\n    border-top: 3px solid var(--vx-c);\n    border-radius: 20px;\n    padding: 24px;\n    color: #eee;\n    cursor: pointer;\n    user-select: none;\n    -webkit-user-select: none;\n    transition: border-color 0.25s ease\n}\n\n.vx_tier_card * {\n    user-select: none;\n    -webkit-user-select: none\n}\n\n.vx_tier_card ::selection {\n    background: transparent\n}\n\n.vx_tier_card.vx_c_one {\n    --vx-c: #b5b5bd\n}\n\n.vx_tier_card.vx_c_two {\n    --vx-c: #e08a4a\n}\n\n.vx_tier_card.vx_c_three {\n    --vx-c: #3ecf8e\n}\n\n.vx_tier_card.vx_c_four {\n    --vx-c: #4f8cff\n}\n\n.vx_tier_card.vx_c_five {\n    --vx-c: #a76bff\n}\n\n.vx_tier_card.vx_c_six {\n    --vx-c: #f1c76a\n}\n\n.vx_tier_card.vx_c_one.is-me:hover {\n    border-color: #b5b5bd;\n    box-shadow: 0px 5px 15px #b5b5bd40;\n}\n\n.vx_tier_card.vx_c_two.is-me:hover {\n    border-color: #e08a4a;\n    box-shadow: 0px 5px 15px #e08a4a40;\n}\n\n.vx_tier_card.vx_c_three.is-me:hover {\n    border-color: #3ecf8e;\n    box-shadow: 0px 5px 15px #3ecf8e40;\n}\n\n.vx_tier_card.vx_c_four.is-me:hover {\n    border-color: #4f8cff;\n    box-shadow: 0px 5px 15px #4f8cff40;\n}\n\n.vx_tier_card.vx_c_five.is-me:hover {\n    border-color: #a76bff;\n    box-shadow: 0px 5px 15px #a76bff40;\n}\n\n.vx_tier_card.vx_c_six.is-me:hover {\n    border-color: #f1c76a;\n    box-shadow: 0px 5px 15px #f1c76a40;\n}\n\n.vx_tier_tag {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    background: var(--vx-c);\n    color: #111;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 3px 10px;\n    border-radius: 20px\n}\n\n.vx_tier_head {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    background: transparent !important\n}\n\n.vx_tier_hex {\n    display: inline-flex;\n    width: 44px;\n    height: 44px;\n    align-items: center;\n    justify-content: center;\n    background: transparent !important\n}\n\n.vx_tier_hex img {\n    max-width: 100%;\n    max-height: 100%\n}\n\n.vx_tier_name {\n    font-size: 20px;\n    font-weight: 700;\n    margin: 0;\n    color: inherit;\n    background: transparent !important\n}\n\n.vx_tier_vol {\n    color: #9a9aa3;\n    font-size: 13px;\n    margin: 16px 0 18px;\n    background: transparent !important\n}\n\n.vx_tier_vol strong {\n    display: block;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 600;\n    margin-top: 3px;\n    background: transparent !important\n}\n\n.vx_tier_fees {\n    display: flex;\n    gap: 10px\n}\n\n.vx_tier_fee {\n    flex: 1;\n    background: #0b0b0d;\n    border-radius: 12px;\n    padding: 10px 12px\n}\n\n.vx_tier_fee span {\n    display: block;\n    color: #80808a;\n    font-size: 11px\n}\n\n.vx_tier_fee strong {\n    color: #fff;\n    font-size: 16px;\n    font-weight: 700\n}\n\n.vx_tier_save {\n    margin: 14px 0 0;\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--vx-c);\n    background: transparent !important\n}\n\n.vx_benefits {\n    padding: 40px 0 60px\n}\n\n.vx_benefits_heading {\n    text-align: center;\n    font-size: 38px;\n    font-weight: 700;\n    margin: 0 0 40px;\n    color: #fff\n}\n\n.vx_benefits_heading span {\n    color: #d9b26a\n}\n\n.vx_benefit_grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 20px\n}\n\n.vx_benefit {\n    position: relative;\n    border-radius: 20px;\n    padding: 28px;\n    transition: transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.28s ease, border-color 0.28s ease;\n    cursor: default;\n}\n\n.vx_benefit:hover {\n    transform: translateY(-4px);\n}\n\n.vx_benefit_featured {\n    grid-column: span 2;\n    display: flex;\n    align-items: center;\n    gap: 24px;\n}\n\n/* Individual Creative Gradients for Dark Theme */\n.vx_benefit_gold,\n.vx_benefit_grid>.vx_benefit:nth-child(1) {\n    background: radial-gradient(120% 120% at 0% 0%, rgba(217, 178, 106, 0.20) 0%, rgba(34, 25, 14, 0.88) 48%, #131316 100%);\n    border: 1px solid rgba(217, 178, 106, 0.32);\n    box-shadow: 0 4px 20px -8px rgba(0, 0, 0, 0.5);\n}\n\n.vx_benefit_gold:hover,\n.vx_benefit_grid>.vx_benefit:nth-child(1):hover {\n    border-color: rgba(217, 178, 106, 0.6);\n    box-shadow: 0 14px 34px -8px rgba(217, 178, 106, 0.22);\n}\n\n.vx_benefit_emerald,\n.vx_benefit_grid>.vx_benefit:nth-child(2) {\n    background: radial-gradient(120% 120% at 0% 0%, rgba(62, 207, 142, 0.18) 0%, rgba(13, 30, 22, 0.88) 48%, #131316 100%);\n    border: 1px solid rgba(62, 207, 142, 0.28);\n    box-shadow: 0 4px 20px -8px rgba(0, 0, 0, 0.5);\n}\n\n.vx_benefit_emerald:hover,\n.vx_benefit_grid>.vx_benefit:nth-child(2):hover {\n    border-color: rgba(62, 207, 142, 0.6);\n    box-shadow: 0 14px 34px -8px rgba(62, 207, 142, 0.22);\n}\n\n.vx_benefit_purple,\n.vx_benefit_grid>.vx_benefit:nth-child(3) {\n    background: radial-gradient(120% 120% at 0% 0%, rgba(167, 107, 255, 0.18) 0%, rgba(26, 17, 42, 0.88) 48%, #131316 100%);\n    border: 1px solid rgba(167, 107, 255, 0.28);\n    box-shadow: 0 4px 20px -8px rgba(0, 0, 0, 0.5);\n}\n\n.vx_benefit_purple:hover,\n.vx_benefit_grid>.vx_benefit:nth-child(3):hover {\n    border-color: rgba(167, 107, 255, 0.6);\n    box-shadow: 0 14px 34px -8px rgba(167, 107, 255, 0.22);\n}\n\n.vx_benefit_blue,\n.vx_benefit_grid>.vx_benefit:nth-child(4) {\n    background: radial-gradient(120% 120% at 0% 0%, rgba(79, 140, 255, 0.18) 0%, rgba(15, 24, 46, 0.88) 48%, #131316 100%);\n    border: 1px solid rgba(79, 140, 255, 0.28);\n    box-shadow: 0 4px 20px -8px rgba(0, 0, 0, 0.5);\n}\n\n.vx_benefit_blue:hover,\n.vx_benefit_grid>.vx_benefit:nth-child(4):hover {\n    border-color: rgba(79, 140, 255, 0.6);\n    box-shadow: 0 14px 34px -8px rgba(79, 140, 255, 0.22);\n}\n\n.vx_benefit_copper,\n.vx_benefit_grid>.vx_benefit:nth-child(5) {\n    background: radial-gradient(120% 120% at 0% 0%, rgba(243, 138, 94, 0.18) 0%, rgba(36, 19, 16, 0.88) 48%, #131316 100%);\n    border: 1px solid rgba(243, 138, 94, 0.28);\n    box-shadow: 0 4px 20px -8px rgba(0, 0, 0, 0.5);\n}\n\n.vx_benefit_copper:hover,\n.vx_benefit_grid>.vx_benefit:nth-child(5):hover {\n    border-color: rgba(243, 138, 94, 0.6);\n    box-shadow: 0 14px 34px -8px rgba(243, 138, 94, 0.22);\n}\n\n.vx_benefit_icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 52px;\n    height: 52px;\n    margin-bottom: 18px;\n    border-radius: 16px;\n    transition: transform 0.25s ease;\n}\n\n.vx_benefit:hover .vx_benefit_icon {\n    transform: scale(1.06);\n}\n\n.vx_benefit_gold .vx_benefit_icon,\n.vx_benefit_grid>.vx_benefit:nth-child(1) .vx_benefit_icon {\n    background: rgba(217, 178, 106, 0.14);\n    border: 1px solid rgba(217, 178, 106, 0.38);\n}\n\n.vx_benefit_emerald .vx_benefit_icon,\n.vx_benefit_grid>.vx_benefit:nth-child(2) .vx_benefit_icon {\n    background: rgba(62, 207, 142, 0.14);\n    border: 1px solid rgba(62, 207, 142, 0.38);\n}\n\n.vx_benefit_purple .vx_benefit_icon,\n.vx_benefit_grid>.vx_benefit:nth-child(3) .vx_benefit_icon {\n    background: rgba(167, 107, 255, 0.14);\n    border: 1px solid rgba(167, 107, 255, 0.38);\n}\n\n.vx_benefit_blue .vx_benefit_icon,\n.vx_benefit_grid>.vx_benefit:nth-child(4) .vx_benefit_icon {\n    background: rgba(79, 140, 255, 0.14);\n    border: 1px solid rgba(79, 140, 255, 0.38);\n}\n\n.vx_benefit_copper .vx_benefit_icon,\n.vx_benefit_grid>.vx_benefit:nth-child(5) .vx_benefit_icon {\n    background: rgba(243, 138, 94, 0.14);\n    border: 1px solid rgba(243, 138, 94, 0.38);\n}\n\n.vx_benefit_icon img {\n    width: 26px;\n    height: 26px\n}\n\n.vx_benefit_featured .vx_benefit_icon {\n    width: 72px;\n    height: 72px;\n    margin: 0;\n    flex: none\n}\n\n.vx_benefit_featured .vx_benefit_icon img {\n    width: 36px;\n    height: 36px\n}\n\n.vx_benefit_title {\n    font-size: 18px;\n    font-weight: 700;\n    margin: 0 0 8px;\n    color: #fff\n}\n\n.vx_benefit_text {\n    margin: 0;\n    color: #9a9aa3;\n    font-size: 14px;\n    line-height: 1.6\n}\n\nbody.light_theme .vx_tier_card {\n    background: #fff !important;\n    border-color: #e6e6ea;\n    border-top-color: var(--vx-c);\n    color: #16161a\n}\n\nbody.light_theme .vx_tier_card:hover,\nbody.light_theme .vx_tier_card.is-me {\n    border-color: var(--vx-c) !important;\n    background: #fff !important;\n    box-shadow: none !important\n}\n\nbody.light_theme .vx_tier_name,\nbody.light_theme .vx_tier_vol strong,\nbody.light_theme .vx_tier_fee strong,\nbody.light_theme .vx_benefits_heading,\nbody.light_theme .vx_benefit_title {\n    color: #16161a\n}\n\nbody.light_theme .vx_benefit_text {\n    color: #4e4e58;\n}\n\nbody.light_theme .vx_tier_fee {\n    background: #f4f4f7\n}\n\n/* Individual Creative Gradients for Light Theme */\nbody.light_theme .vx_benefit_gold,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(1) {\n    background: linear-gradient(135deg, #fffbf2 0%, #fef3dc 50%, #ffffff 100%);\n    border: 1px solid #ebd4a4;\n    box-shadow: 0 4px 16px -4px rgba(217, 178, 106, 0.18);\n}\n\nbody.light_theme .vx_benefit_gold:hover,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(1):hover {\n    border-color: #d9b26a;\n    box-shadow: 0 12px 28px -6px rgba(217, 178, 106, 0.32);\n}\n\nbody.light_theme .vx_benefit_gold .vx_benefit_icon,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(1) .vx_benefit_icon {\n    background: rgba(217, 178, 106, 0.18);\n    border-color: rgba(217, 178, 106, 0.45);\n}\n\nbody.light_theme .vx_benefit_emerald,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(2) {\n    background: linear-gradient(135deg, #f0fbf6 0%, #ddf7eb 50%, #ffffff 100%);\n    border: 1px solid #a9e4cc;\n    box-shadow: 0 4px 16px -4px rgba(62, 207, 142, 0.18);\n}\n\nbody.light_theme .vx_benefit_emerald:hover,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(2):hover {\n    border-color: #3ecf8e;\n    box-shadow: 0 12px 28px -6px rgba(62, 207, 142, 0.32);\n}\n\nbody.light_theme .vx_benefit_emerald .vx_benefit_icon,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(2) .vx_benefit_icon {\n    background: rgba(62, 207, 142, 0.18);\n    border-color: rgba(62, 207, 142, 0.45);\n}\n\nbody.light_theme .vx_benefit_purple,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(3) {\n    background: linear-gradient(135deg, #f8f3ff 0%, #ede1fc 50%, #ffffff 100%);\n    border: 1px solid #d3baf9;\n    box-shadow: 0 4px 16px -4px rgba(167, 107, 255, 0.18);\n}\n\nbody.light_theme .vx_benefit_purple:hover,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(3):hover {\n    border-color: #a76bff;\n    box-shadow: 0 12px 28px -6px rgba(167, 107, 255, 0.32);\n}\n\nbody.light_theme .vx_benefit_purple .vx_benefit_icon,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(3) .vx_benefit_icon {\n    background: rgba(167, 107, 255, 0.18);\n    border-color: rgba(167, 107, 255, 0.45);\n}\n\nbody.light_theme .vx_benefit_blue,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(4) {\n    background: linear-gradient(135deg, #f1f6ff 0%, #dfeafe 50%, #ffffff 100%);\n    border: 1px solid #b5d1fe;\n    box-shadow: 0 4px 16px -4px rgba(79, 140, 255, 0.18);\n}\n\nbody.light_theme .vx_benefit_blue:hover,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(4):hover {\n    border-color: #4f8cff;\n    box-shadow: 0 12px 28px -6px rgba(79, 140, 255, 0.32);\n}\n\nbody.light_theme .vx_benefit_blue .vx_benefit_icon,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(4) .vx_benefit_icon {\n    background: rgba(79, 140, 255, 0.18);\n    border-color: rgba(79, 140, 255, 0.45);\n}\n\nbody.light_theme .vx_benefit_copper,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(5) {\n    background: linear-gradient(135deg, #fff4f0 0%, #fedfd5 50%, #ffffff 100%);\n    border: 1px solid #f6beae;\n    box-shadow: 0 4px 16px -4px rgba(243, 138, 94, 0.18);\n}\n\nbody.light_theme .vx_benefit_copper:hover,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(5):hover {\n    border-color: #f38a5e;\n    box-shadow: 0 12px 28px -6px rgba(243, 138, 94, 0.32);\n}\n\nbody.light_theme .vx_benefit_copper .vx_benefit_icon,\nbody.light_theme .vx_benefit_grid>.vx_benefit:nth-child(5) .vx_benefit_icon {\n    background: rgba(243, 138, 94, 0.18);\n    border-color: rgba(243, 138, 94, 0.45);\n}\n\n@media (max-width:991px) {\n\n    .vx_tier_grid,\n    .vx_benefit_grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr))\n    }\n\n    .vx_benefit_featured {\n        grid-column: span 2\n    }\n}\n\n@media (max-width: 767px) {\n\n    .vip_tier_section {\n        padding: 40px 0 20px;\n    }\n\n    .vx_benefits_heading {\n        font-size: 28px;\n    }\n\n    .vip button.applybtn,\n    .vip a.applybtn {\n        font-size: 13px;\n        padding: 8px 24px;\n    }\n\n    .vip a.vip-hero-secondary {\n        font-size: 13px;\n        padding: 8px 24px;\n    }\n\n    .commingsoon h2 {\n        font-size: 36px;\n    }\n\n    .vip_features_section h2 {\n        font-size: 24px;\n    }\n\n    .vip_features_section h3 {\n        font-size: 16px;\n    }\n\n    .vip_feature_middle_img {\n        margin-top: 0px;\n    }\n\n    .vip_tier_table_wrapper {\n        padding: 4px 20px 10px;\n        box-shadow: none;\n    }\n\n    .vip_features_section {\n        padding: 0px 0px 20px;\n    }\n\n    .tier_badge img.table_vector_effect {\n        display: none;\n    }\n\n    .vip_features_section p {\n        font-size: 13px;\n    }\n\n    .vip_features_vector {\n        min-width: 40px;\n        width: 40px;\n    }\n\n    .vip_features_cntblock {\n        padding-right: 0px;\n        margin-top: 10px;\n    }\n\n    .vip_feature_card_top {\n        position: absolute;\n        top: 20px;\n        width: 90%;\n    }\n\n    .vip_tier_table {\n        margin-top: 0;\n        border-spacing: 0;\n    }\n\n    .vip_tier_table,\n    .vip_tier_table tbody,\n    .vip_tier_table tr,\n    .vip_tier_table td {\n        display: block;\n        width: 100%;\n    }\n\n    .vip_tier_table thead {\n        display: none;\n    }\n\n    .vip_tier_table tr {\n        /* background: #000; */\n        /* border: 1px solid #d1aa6761; */\n        /* border-radius: 12px; */\n        margin-bottom: 0px;\n        padding: 0;\n\n    }\n\n    .vip_tier_table tbody tr {\n        border-top: none;\n    }\n\n    .vip_tier_table td {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 12px 0;\n        text-align: right;\n        font-size: 12px;\n    }\n\n    .vip_tier_table td:last-child {\n        border-bottom: none;\n    }\n\n    .vip_tier_table td::before {\n        content: attr(data-label);\n        font-weight: 500;\n        color: #D1AA67;\n        text-align: left;\n        margin-right: 15px;\n    }\n\n    .vip_prime_title {\n        font-size: 32px;\n    }\n\n    .metric_value {\n        font-size: 18px;\n        line-height: 24px;\n    }\n\n    .vip_prime_title_container {\n        padding-top: 40px;\n        margin-bottom: 0px;\n    }\n\n    .vip_prime_card_left {\n        padding: 20px;\n        margin: 0px;\n        position: relative;\n        z-index: 999;\n    }\n\n    .metric_unit {\n        font-size: 18px;\n    }\n\n    .vip_prime_section::before {\n        height: 190px;\n        background: linear-gradient(0deg, rgb(0 0 0) -10%, rgb(4 4 4) 100%);\n    }\n\n    .coin_name {\n        font-size: 18px;\n    }\n\n    .vip_prime_title {\n        color: #fffbf5;\n    }\n\n    .vip_prime_card {\n        flex-direction: column;\n    }\n\n    .vip_prime_card_right {\n        width: 100%;\n        padding: 10px 20px 24px;\n    }\n\n    .vip_tier_title {\n        font-size: 22px;\n        border-bottom: 2px solid #D1AA67;\n    }\n\n    .vip_prime_section {\n        padding: 30px 0 20px;\n        background-size: 100%;\n    }\n\n    .vip_tier_title_container {\n        margin-bottom: 20px;\n    }\n\n    .vip_features_title_container {\n        margin-bottom: 10px;\n    }\n\n    .vip_feature_card.vip_feature_card_tall {\n        height: 100%;\n        padding: 0px;\n    }\n\n\n\n    .vip_feature_card_heading {\n        font-size: 18px;\n    }\n\n    .vip_cards_section {\n        min-height: 350px;\n        padding-top: 30px;\n        background-size: 320px;\n    }\n\n    .vip_features_grid {\n        gap: 18px;\n    }\n\n    .desktop_only_cell {\n        display: none !important;\n    }\n\n    .mobile_more_btn {\n        display: inline-flex !important;\n        align-items: center;\n        justify-content: center;\n        background: none;\n        border: none;\n        color: #D1AA67;\n        margin-left: 10px;\n        cursor: pointer;\n        padding: 5px;\n    }\n\n    .mobile_td_right {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n    }\n}\n\n@media (max-width: 600px) {\n\n    .commingsoon h2 {\n        font-size: 32px;\n    }\n\n    .vip_features_grid {\n        grid-template-columns: 1fr;\n    }\n\n    .vip_feature_card_tall {\n        grid-row: span 1;\n    }\n\n    .vip_features_title {\n        font-size: 24px;\n    }\n\n    .vip_hero_img {\n        max-width: 190px;\n    }\n\n    .vip_feature_card_heading {\n        font-size: 18px;\n    }\n\n    .vip_feature_card_desc {\n        font-size: 14px;\n    }\n\n    .vip_hero_section h1 {\n        font-size: 22px;\n    }\n\n    .vip_hero_section p {\n        font-size: 14px;\n        padding: 0px;\n        margin: 0px;\n    }\n\n    .vip button {\n        font-size: 14px;\n        padding: 7px 24px;\n    }\n\n    .vip_cnt_mdp {\n        top: 0px;\n    }\n\n    .right_metric {\n        margin-bottom: 10px;\n    }\n\n    .metrics_container {\n        gap: 24px;\n    }\n\n    .right_title {\n        font-size: 16px;\n    }\n\n    .right_value {\n        font-size: 24px;\n    }\n\n    .join_btn {\n        padding: 8px 0;\n    }\n\n    .vip_features_section {\n        padding: 30px 0px 20px;\n    }\n\n    .gold_badge {\n        font-size: 11px;\n    }\n\n    .commingsoon {\n        padding: 24px 0px 0px;\n    }\n\n    .vip_prime_title_container {\n        padding-top: 10px;\n        padding-bottom: 10px;\n    }\n\n    .vip_feature_card_img {\n        top: 0px;\n    }\n\n    .vip_hero_section:before {\n        bottom: -26px;\n    }\n\n    .tier_badge img {\n        height: 36px;\n        left: 29px;\n    }\n\n    span.tier_subtext {\n        padding-left: 34px;\n        left: 0px;\n    }\n\n}\n\n@media (max-width:640px) {\n\n    .vx_tier_grid,\n    .vx_benefit_grid {\n        grid-template-columns: 1fr\n    }\n\n    .vx_benefit_featured {\n        grid-column: auto;\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .vx_benefits_heading {\n        font-size: 22px;\n        margin: 0 0 20px;\n    }\n\n    .vx_benefits {\n        padding: 20px 0 40px\n    }\n\n    .vip_market_tab {\n        padding: 6px 15px;\n        font-size: 13px;\n    }\n\n    .vip_market_tabs {\n        margin: 40px auto 18px;\n    }\n}\n\n@media (max-width: 330px) {\n\n    .vip_market_tab {\n        padding: 5px 13px;\n        font-size: 12px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
